import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Tabs,
  Checkbox,
  Progress,
  Menu,
  Dropdown,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Styled, StyledTab, DisabledButtonStyle } from "../../pageStyled";
// import ResendApprovalData from "../OrderDetailDrawer/resendApproval";
import ResendApprovalData from "../../OrderEntry/OrderDetailDrawer/resendApprovalNewDrawer";
import ApprovalRequestChanges from "../OrderDetailDrawer/approvalRequestChanges";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import ApprovalHeader from "./approvalHeader";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import ViewApprovalOrderDrawer from "../OrderDetailDrawer/viewApprovalOrders";
import ActionDrawer from "../OrderDetailDrawer/ActionDrawer";
import ProductionDetailsDrawer from "../OrderDetailDrawer/productionDetailsDrawer";
import HoldApprovalOrdersData from "../OrderDetailDrawer/holdApprovalOrders";
import ApproveOrderHeader from "./approveOrderHeader";
import {
  bulkChangeOrderState,
  changeOrderPriority,
  getApprovedOrdersList,
  getFilteredApproveOrders,
  getSplitGroupOrders,
  rejectOrApproveOrder,
  searchApproveOrderRecords,
} from "../../../Services/orderServices";
import moment from "moment";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { useNavigate, useLocation } from "react-router";
import EditNewOrderDrawer from "../OrderDetailDrawer/editOrderDetails";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import Paragraph from "antd/lib/typography/Paragraph";
import styled from "styled-components";
import {
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import { getProductsData } from "../../../Services/productServices";
import MultiDiaEditOrderDrawer from "../OrderDetailDrawer/multiDiaEditOrderDrawer";
import SplitOrderDrawer from "../OrderDetailDrawer/splitOrderDrawer";
import MergeDrawer from "../OrderDetailDrawer/MergeOrderDrawer";
import CancelQuantityDrawer from "../OrderDetailDrawer/cancelQuantityDrawer";
import ViewProcessedQuantityDrawer from "../OrderDetailDrawer/viewProcessedQuantityDrawer";
import ViewPendingQuantityDrawer from "../OrderDetailDrawer/PendingQuantityDrawer";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const TooltipSelector = styled.div`
  .edit-tooltip .ant-tooltip-inner {
    padding: 7px !important;
    background: rgba(32, 31, 30, 0.85) !important;
    border-radius: 40px !important;
    font-family: var(--sf-pro-display-m);
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
  }
  .edit-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
    top: 3px;
    right: 13px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b !important;
    border-color: #dfe1e6 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #ea655b !important;
  }
  .ant-checkbox-checked::after {
    border-color: #ea655b !important;
  }
`;
const OrderSummary = styled.div`
  .orderSummaryStyle {
    display: block;
    text-align: right;
    padding-bottom: 16px;
    font-size: 14px;
    font-family: var(--sf-pro-display-m);
    color: var(--theme-color);
    line-height: 16px;
  }
  .orderWeightStyle {
    padding-right: 20px;
  }
`;
const Panes = Tabs.TabPane;

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const ApproveOrdersData = (props) => {
  const location = useLocation();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [viewPendingDrawer, setviewPendingDrawer] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [splitOrderSideDrawer, setSplitOrderSideDrawer] = useState(false);
  const [processedQtyDetailsSideDrawer, setProcessedQtyDetailsSideDrawer] =
    useState(false);
  const [pendingQtyDetailsSideDrawer, setPendingQtyDetailsSideDrawer] =
    useState(false);
  const [mergeSideDrawer, setMergeDrawer] = useState(false);
  const [cancelQuantitySideDrawer, setCancelQuantitySideDrawer] =
    useState(false);
  const [resendApprovalData, setResendApprovalData] = useState(false);
  const [orderChangeRequestDrawer, setOrderChangeRequestDrawer] =
    useState(false);
  const [rejectOrders, setRejectOrders] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isVisiblePriorityModal, setIsVisiblePriorityModal] = useState(false);
  const [holdOrders, setHoldOrders] = useState(false);
  const [allOrdersList, setAllOrdersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [orderState, setOrderState] = useState(
    location?.state?.defaultOrderState
      ? location?.state?.defaultOrderState
      : "pending"
  );
  const [selectedPendingOrders, setSelectedPendingOrders] = useState([]);
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [showPriorityOrders, setShowPriorityOrders] = useState(false);
  const [reFetch, setReFetch] = useState(true);
  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, search: 140, table: 226 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;
      const searchHeight = searchRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        search: baseTop + titleHeight + tabsHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);
    if (searchRef.current) observer.observe(searchRef.current);

    return () => observer.disconnect();
  }, [reFetch]);

  const [toaster, setToaster] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [actionResponse, setActionResponse] = useState({
    error: true,
    msg: "",
  });
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: 10,
  });
  const [sortParams, setSortParams] = useState({
    sort_by: "updated_at",
    sort_type: "descending",
  });
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
      JSON.parse(localStorage.getItem("setting-data"))
  );
  const [activeTab, setActiveTab] = useState("1");
  const [clearSearch, setClearSearch] = useState(false);
  const [orderAction, setOrderAction] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [allInnerRecords, setAllInnerRecords] = useState({});
  const [nestedLoading, setNestedLoading] = useState(true);
  const [isStateData, setStateData] = useState(false);
  const [defaultActiveKey, setDefaultActiveKey] = useState(
    location?.state?.defaultActiveKey ? location?.state?.defaultActiveKey : "0"
  );
  const [orderWeightCount, setOrderWeightCount] = useState();
  const [productionDetailsSideDrawer, setProductionDetailsSideDrawer] =
    useState(false);
  const paginationRef = useRef({ page: 1, size: 10 });
  const currentState = useRef("pending");
  const sorterRef = useRef({
    field: "updated_at",
    order: "descend",
  });
  const [measurementData, setMeasurementData] = useState();
  const [poCount, setPOCount] = useState();
  const [soCount, setSOCount] = useState();
  const [isAllSelected, setIsAllSelected] = useState(false);
const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const [deckleManagementSettings, setDeckleManagementSettings] = useState({});
  // const columnsPendingHead = useRef([
  //   // {
  //   //   title: "Select",
  //   //   dataIndex: "checked",
  //   //   width: "8%",
  //   //   fixed: "left",
  //   //   align: "center",
  //   //   render: (value, record, rowIndex) => (
  //   //     <Styled>
  //   //       <Checkbox
  //   //         checked={value}
  //   //         onChange={handleCheckboxChangeFactory(
  //   //           rowIndex,
  //   //           "checked",
  //   //           tableData,
  //   //           setTableData,
  //   //           setSelectedPendingOrders,
  //   //           record
  //   //         )}
  //   //       />
  //   //     </Styled>
  //   //   ),
  //   // },
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //             style={{
  //               whiteSpace: "normal",
  //               lineHeight: "1.2",
  //               textAlign: "left",
  //             }}
  //           >
  //             {`#${record.category === "PO" ? record.pono : record.sono}`
  //               .match(/.{1,15}/g)
  //               ?.map((chunk, index) => (
  //                 <span key={index}>
  //                   {chunk}
  //                   <br />
  //                 </span>
  //               ))}
  //           </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "20%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Approve this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleApprove(record)}>
  //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Reject this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               disabled={record.priority}
  //               onClick={() => handleReject(record.orderno)}
  //             >
  //               <Iconmoon icon="wrong-file" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Request changes in this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleChangeRequest(record.orderno)}>
  //               <Iconmoon icon="refresh" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               {(userDetails.roles.approve_orders ||
  //                 (userDetails.roles.approve_orders &&
  //                   userDetails.id == record.user)) &&
  //                 record?.status == "Approved" &&
  //                 !record?.priority &&
  //                 record?.pendingQuantityValue != 0 && (
  //                   <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleSplitAction(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"Mapping"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           Split this order
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {record.status !== "Cancelled" &&
  //                 record?.split_type != "auto" &&
  //                 record.split_group &&
  //                 record.status == "Approved" &&
  //                 !record?.priority &&
  //                 record.completed == 0 &&
  //                 record.in_production == 0 &&
  //                 record.in_process == 0 &&
  //                 record.parent && (
  //                   <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => onMergeOrderHandler(record, "menuEle")}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "-1px" }}>
  //                             <Iconmoon
  //                               icon={"export"}
  //                               size={14}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-3px", marginLeft: "11px" }}
  //                           >
  //                             Merge order
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                 )}
  //               {record.status == "Approved" &&
  //                 record.pendingQuantityValue > 0 && (
  //                   <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => handleCancelledQuantityAction(record)}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Quantity
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="4" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProdDetailsAction(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"production"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Production Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProcessedQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Processed Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {[
  //                 "On Hold",
  //                 "Approved",
  //                 "Open",
  //                 "Changes Req",
  //                 "Pending",
  //               ].includes(record?.status) && (
  //                 <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewPendingQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Pending Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewPODetailsHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                         {record.category === "PO"
  //                           ? "View PO Details"
  //                           : "View SO Details"}
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewChangeHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"changeHistory"}
  //                           size={19}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                         View Change History
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               {(record.status == "Approved" &&
  //                 record.processQuantity?.split(" ")[0] == 0) ||
  //               record.status == "On Hold" ||
  //               record.status == "Pending" ||
  //               record.status == "Changes Req" ||
  //               record.status == "Rejected" ? (
  //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => handleCancel(record)}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Order
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>
  //               ) : (
  //                 ""
  //               )}
  //             </Menu>
  //           }
  //           placement="bottom"
  //           arrow
  //         >
  //           <DisabledButtonStyle>
  //             <Button>
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </DisabledButtonStyle>
  //         </Dropdown>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);
  // const columnsChangesReqHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //             style={{
  //               whiteSpace: "normal",
  //               lineHeight: "1.2",
  //               textAlign: "left",
  //             }}
  //           >
  //             {`#${record.category === "PO" ? record.pono : record.sono}`
  //               .match(/.{1,15}/g)
  //               ?.map((chunk, index) => (
  //                 <span key={index}>
  //                   {chunk}
  //                   <br />
  //                 </span>
  //               ))}
  //           </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "8%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Approve this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleApprove(record)}>
  //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Reject this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               disabled={record.priority}
  //               onClick={() => handleReject(record.orderno)}
  //             >
  //               <Iconmoon icon="wrong-file" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Request changes in this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={showOrderChangeRequestDrawer}>
  //               <Iconmoon icon="refresh" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               {(userDetails.roles.approve_orders ||
  //                 (userDetails.roles.approve_orders &&
  //                   userDetails.id == record.user)) &&
  //                 record?.status == "Approved" &&
  //                 !record?.priority &&
  //                 record?.pendingQuantityValue != 0 && (
  //                   <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleSplitAction(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"Mapping"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           Split this order
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {record.status !== "Cancelled" &&
  //                 record?.split_type != "auto" &&
  //                 record.split_group &&
  //                 record.status == "Approved" &&
  //                 !record?.priority &&
  //                 record.completed == 0 &&
  //                 record.in_production == 0 &&
  //                 record.in_process == 0 &&
  //                 record.parent && (
  //                   <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => onMergeOrderHandler(record, "menuEle")}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "-1px" }}>
  //                             <Iconmoon
  //                               icon={"export"}
  //                               size={14}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-3px", marginLeft: "11px" }}
  //                           >
  //                             Merge order
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                 )}
  //               {record.status == "Approved" &&
  //                 record.pendingQuantityValue > 0 && (
  //                   <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => handleCancelledQuantityAction(record)}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Quantity
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="4" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProdDetailsAction(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"production"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Production Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProcessedQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Processed Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {[
  //                 "On Hold",
  //                 "Approved",
  //                 "Open",
  //                 "Changes Req",
  //                 "Pending",
  //               ].includes(record?.status) && (
  //                 <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewPendingQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Pending Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewPODetailsHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                         {record.category === "PO"
  //                           ? "View PO Details"
  //                           : "View SO Details"}
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewChangeHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"changeHistory"}
  //                           size={19}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                         View Change History
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               {(record.status == "Approved" &&
  //                 record.processQuantity?.split(" ")[0] == 0) ||
  //               record.status == "On Hold" ||
  //               record.status == "Pending" ||
  //               record.status == "Changes Req" ||
  //               record.status == "Rejected" ? (
  //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => handleCancel(record)}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Order
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>
  //               ) : (
  //                 ""
  //               )}
  //             </Menu>
  //           }
  //           placement="bottom"
  //           arrow
  //         >
  //           <DisabledButtonStyle>
  //             <Button>
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </DisabledButtonStyle>
  //         </Dropdown>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);
  // const columnsApprovedHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //             style={{
  //               whiteSpace: "normal",
  //               lineHeight: "1.2",
  //               textAlign: "left",
  //             }}
  //           >
  //             {`#${record.category === "PO" ? record.pono : record.sono}`
  //               .match(/.{1,15}/g)
  //               ?.map((chunk, index) => (
  //                 <span key={index}>
  //                   {chunk}
  //                   <br />
  //                 </span>
  //               ))}
  //           </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "16%",
  //     render: (text, record) =>
  //       record.item_type === "order" ? (
  //         <div className="actionBtn">
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={
  //                 record.priority ? "Remove priority" : "Prioritize this order"
  //               }
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handlePrioritize(record);
  //                 }}
  //               >
  //                 <Iconmoon
  //                   icon={record.priority ? "low-priority" : "high-priority"}
  //                   size={16}
  //                   color={record.priority ? "#ea4e2c" : "#3fbd61"}
  //                 />
  //               </Button>
  //               {/* Based on the priority change icon name as "high-priority" and "low-priority" and change the color code as "#3fbd61" and "#3fbd61" */}
  //             </Tooltip>
  //           </Styled>
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Hold this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 disabled={record.priority}
  //                 onClick={() => handleHold(record.orderno)}
  //               >
  //                 <Iconmoon icon="hold" size={16} color="#ea4e2c" />
  //               </Button>
  //               {/* Based on the Hold status change the color code as "#ea4e2c" and "#3fbd61" */}
  //             </Tooltip>
  //           </Styled>
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"View this order"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleViewAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //           {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View Production Details"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewProdDetailsAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //           <Dropdown
  //             overlay={
  //               <Menu>
  //                 {(userDetails.roles.approve_orders ||
  //                   (userDetails.roles.approve_orders &&
  //                     userDetails.id == record.user)) &&
  //                   record?.status == "Approved" &&
  //                   !record?.priority &&
  //                   record?.pendingQuantityValue != 0 && (
  //                     <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => {
  //                           handleSplitAction(record);
  //                         }}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "8px" }}>
  //                             <Iconmoon
  //                               icon={"Mapping"}
  //                               size={17}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "5px", marginLeft: "6px" }}
  //                           >
  //                             Split this order
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}
  //                 {record.status !== "Cancelled" &&
  //                   record?.split_type != "auto" &&
  //                   record.split_group &&
  //                   record.status == "Approved" &&
  //                   !record?.priority &&
  //                   record.completed == 0 &&
  //                   record.in_production == 0 &&
  //                   record.in_process == 0 &&
  //                   record.parent && (
  //                     <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                       <DisabledButtonStyle>
  //                         <Button
  //                           style={{
  //                             border: "none",
  //                             background: "none",
  //                             padding: "0",
  //                             font: "inherit",
  //                             textAlign: "left",
  //                             width: "100%",
  //                             color: "black",
  //                           }}
  //                           className="themeBtn noBg"
  //                           onClick={() =>
  //                             onMergeOrderHandler(record, "menuEle")
  //                           }
  //                         >
  //                           <div
  //                             style={{ display: "flex", flexDirection: "row" }}
  //                           >
  //                             <div style={{ marginTop: "-1px" }}>
  //                               <Iconmoon
  //                                 icon={"export"}
  //                                 size={14}
  //                                 color="#605E5C"
  //                               />{" "}
  //                             </div>
  //                             <div
  //                               style={{
  //                                 marginTop: "-3px",
  //                                 marginLeft: "11px",
  //                               }}
  //                             >
  //                               Merge order
  //                             </div>
  //                           </div>
  //                         </Button>
  //                       </DisabledButtonStyle>
  //                     </Menu.Item>
  //                   )}
  //                 {record.status == "Approved" &&
  //                   record.pendingQuantityValue > 0 && (
  //                     <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => handleCancelledQuantityAction(record)}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"wrong"}
  //                               size={15}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             Cancel Quantity
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </Menu.Item>
  //                   )}
  //                 {["On Hold", "Approved"].includes(record?.status) && (
  //                   <Menu.Item key="4" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleViewProdDetailsAction(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"production"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           View Production Details
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //                 {["On Hold", "Approved"].includes(record?.status) && (
  //                   <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleViewProcessedQtyDetails(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"viewPODetails"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           View Processed Quantity Details
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //                 {[
  //                   "On Hold",
  //                   "Approved",
  //                   "Open",
  //                   "Changes Req",
  //                   "Pending",
  //                 ].includes(record?.status) && (
  //                   <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleViewPendingQtyDetails(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"viewPODetails"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           View Pending Quantity Details
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //                 <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => {
  //                         onViewPODetailsHandler(record);
  //                       }}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"viewPODetails"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           {record.category === "PO"
  //                             ? "View PO Details"
  //                             : "View SO Details"}
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>

  //                 <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => {
  //                         onViewChangeHandler(record);
  //                       }}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"changeHistory"}
  //                             size={19}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                           View Change History
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>

  //                 {(record.status == "Approved" &&
  //                   record.processQuantity?.split(" ")[0] == 0) ||
  //                 record.status == "On Hold" ||
  //                 record.status == "Pending" ||
  //                 record.status == "Changes Req" ||
  //                 record.status == "Rejected" ? (
  //                   <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         onClick={() => handleCancel(record)}
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "0px" }}>
  //                             <Iconmoon
  //                               icon={"wrong"}
  //                               size={15}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-2px", marginLeft: "6px" }}
  //                           >
  //                             Cancel Order
  //                           </div>
  //                         </div>
  //                       </Button>{" "}
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                 ) : (
  //                   ""
  //                 )}
  //               </Menu>
  //             }
  //             placement="bottom"
  //             arrow
  //           >
  //             <DisabledButtonStyle>
  //               <Button>
  //                 <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //               </Button>
  //             </DisabledButtonStyle>
  //           </Dropdown>
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //     align: "center",
  //   },
  // ]);
  // const columnsRejectedHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //             style={{
  //               whiteSpace: "normal",
  //               lineHeight: "1.2",
  //               textAlign: "left",
  //             }}
  //           >
  //             {`#${record.category === "PO" ? record.pono : record.sono}`
  //               .match(/.{1,15}/g)
  //               ?.map((chunk, index) => (
  //                 <span key={index}>
  //                   {chunk}
  //                   <br />
  //                 </span>
  //               ))}
  //           </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "12%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Release this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleApprove(record)}>
  //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View Production Details"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewProdDetailsAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               <Menu.Item key="1" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewPODetailsHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                         {record.category === "PO"
  //                           ? "View PO Details"
  //                           : "View SO Details"}
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewChangeHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"changeHistory"}
  //                           size={19}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                         View Change History
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               {(record.status == "Approved" &&
  //                 record.processQuantity?.split(" ")[0] == 0) ||
  //               record.status == "On Hold" ||
  //               record.status == "Pending" ||
  //               record.status == "Changes Req" ||
  //               record.status == "Rejected" ? (
  //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => handleCancel(record)}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Order
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>
  //               ) : (
  //                 ""
  //               )}
  //             </Menu>
  //           }
  //           placement="bottom"
  //           arrow
  //         >
  //           <DisabledButtonStyle>
  //             <Button>
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </DisabledButtonStyle>
  //         </Dropdown>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);
  // const columnsOnHoldHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           <div
  //             style={{
  //               whiteSpace: "normal",
  //               lineHeight: "1.2",
  //               textAlign: "left",
  //             }}
  //           >
  //             {`#${record.category === "PO" ? record.pono : record.sono}`
  //               .match(/.{1,15}/g)
  //               ?.map((chunk, index) => (
  //                 <span key={index}>
  //                   {chunk}
  //                   <br />
  //                 </span>
  //               ))}
  //           </div>
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "12%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Release this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleApprove(record)}>
  //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View Production Details"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewProdDetailsAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               {(userDetails.roles.approve_orders ||
  //                 (userDetails.roles.approve_orders &&
  //                   userDetails.id == record.user)) &&
  //                 record?.status == "Approved" &&
  //                 !record?.priority &&
  //                 record?.pendingQuantityValue != 0 && (
  //                   <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleSplitAction(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"Mapping"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           Split this order
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {record.status !== "Cancelled" &&
  //                 record?.split_type != "auto" &&
  //                 record.split_group &&
  //                 record.status == "Approved" &&
  //                 !record?.priority &&
  //                 record.completed == 0 &&
  //                 record.in_production == 0 &&
  //                 record.in_process == 0 &&
  //                 record.parent && (
  //                   <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => onMergeOrderHandler(record, "menuEle")}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "-1px" }}>
  //                             <Iconmoon
  //                               icon={"export"}
  //                               size={14}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-3px", marginLeft: "11px" }}
  //                           >
  //                             Merge order
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                 )}
  //               {record.status == "Approved" &&
  //                 record.pendingQuantityValue > 0 && (
  //                   <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => handleCancelledQuantityAction(record)}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Quantity
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="4" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProdDetailsAction(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"production"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Production Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProcessedQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Processed Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {[
  //                 "On Hold",
  //                 "Approved",
  //                 "Open",
  //                 "Changes Req",
  //                 "Pending",
  //               ].includes(record?.status) && (
  //                 <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewPendingQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Pending Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewPODetailsHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                         {record.category === "PO"
  //                           ? "View PO Details"
  //                           : "View SO Details"}
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewChangeHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"changeHistory"}
  //                           size={19}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                         View Change History
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               {(record.status == "Approved" &&
  //                 record.processQuantity?.split(" ")[0] == 0) ||
  //               record.status == "On Hold" ||
  //               record.status == "Pending" ||
  //               record.status == "Changes Req" ||
  //               record.status == "Rejected" ? (
  //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => handleCancel(record)}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Order
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>
  //               ) : (
  //                 ""
  //               )}
  //             </Menu>
  //           }
  //           placement="bottom"
  //           arrow
  //         >
  //           <DisabledButtonStyle>
  //             <Button>
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </DisabledButtonStyle>
  //         </Dropdown>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);
  // const columnsCompleteHead = useRef([
  //   {
  //     title: "Po/So .No",
  //     dataIndex: "pono",
  //     width: "12.5%",
  //     fixed: "left",
  //     key: "pono",
  //     align: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
  //     render: (text, record) => (
  //       <div className="">
  //         <Button
  //           style={{ background: "transparent" }}
  //           className="textTypeBtn textBtnIcon"
  //           onClick={() => handlePo(record)}
  //         >
  //           {`#${record.category === "PO" ? record.pono : record.sono}`}
  //         </Button>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Group No",
  //   //   dataIndex: "groupno",
  //   //   width: "6.5%",
  //   //   fixed: "left",
  //   //   sorter: () => {},
  //   //   // sortOrder: "null",
  //   // },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     key: "orderno",
  //     width: "8%",
  //     fixed: "left",
  //     sorter: () => {},
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         {record?.previous_state?.old &&
  //         record?.previous_state?.new &&
  //         (record?.previous_state?.old === "review" ||
  //           record?.previous_state?.old === "approved" ||
  //           record?.previous_state?.old === "cancel") &&
  //         record.status === "Pending" ? (
  //           // <Styled >
  //           <TooltipSelector>
  //             <Tooltip
  //               overlayInnerStyle={{
  //                 borderRadius: "8px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 padding: "7px",
  //                 background: "rgba(32, 31, 30, 0.85)",
  //                 fontFamily: "var(--sf-pro-display-m)",
  //                 fontStyle: "normal",
  //                 fontSize: "12px",
  //                 lineHeight: "16px",
  //               }}
  //               placement="bottomRight"
  //               title={
  //                 record?.previous_state?.old === "review"
  //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
  //                   : record?.previous_state?.old === "cancel"
  //                   ? "This order has been sent for approval again. This order was cancelled previously."
  //                   : "This order has been sent for approval again. This order was approved previously."
  //               }
  //               // getPopupContainer={(triggerNode) => triggerNode}
  //               overlayClassName="edit-tooltip"
  //             >
  //               <Button
  //                 style={{ background: "transparent" }}
  //                 className="textTypeBtn textBtnIcon"
  //                 onClick={() => handleViewAction(record)}
  //               >
  //                 {`${text}`}
  //               </Button>
  //             </Tooltip>
  //           </TooltipSelector>
  //         ) : text != "-" ? (
  //           // </Styled>
  //           <Button
  //             style={{ background: "transparent" }}
  //             className="textTypeBtn textBtnIcon"
  //             onClick={() => handleViewAction(record)}
  //           >
  //             {`${text}`}
  //           </Button>
  //         ) : (
  //           <span style={{ textAlign: "center" }}>{text}</span>
  //         )}
  //         {record?.previous_state?.old &&
  //           record?.previous_state?.new &&
  //           (record?.previous_state?.old === "review" ||
  //             record?.previous_state?.old === "approved" ||
  //             record?.previous_state?.old === "cancel") &&
  //           record.status === "Pending" && (
  //             <div>
  //               <span
  //                 style={{
  //                   color: "rgb(234, 101, 91)",
  //                   fontStyle: "italic",
  //                   fontSize: "10px",
  //                 }}
  //               >
  //                 Resent for approval
  //               </span>
  //             </div>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "PO/SO Date",
  //     dataIndex: "poDate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => {
  //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
  //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
  //         return dateA - dateB;
  //       },
  //     },
  //     render: (text, record) =>
  //       record.category === "SO" ? record.sodate : record.podate,
  //   },
  //   { title: "Category", dataIndex: "category", width: "7%", align: "left" },
  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "7%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias || "-"}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "10.8%",
  //   },
  //   // {
  //   //   title: "Type",
  //   //   dataIndex: "type",
  //   //   width: "5.8%",
  //   // },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "PLY",
  //     dataIndex: "ply",
  //     width: "8.4%",
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "7.4%",
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         {record.type.toLowerCase() == "sheet" &&
  //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
  //           <>
  //             <span style={{ textAlign: "center" }}>{text}</span>
  //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
  //           </>
  //         ) : (
  //           `${text} `
  //         )}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Processed Quantity",
  //     dataIndex: "processQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text} `
  //         : "-",
  //   },
  //   {
  //     title: "Cancelled Quantity",
  //     dataIndex: "cancelledQuantity",
  //     width: "7.4%",
  //     render: (text, record) =>
  //       parseFloat(text) && record.type
  //         ? `${text}`
  //         : parseFloat(text)
  //         ? `${text}`
  //         : "-",
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
  //   // },
  //   // {
  //   //   title: "Planned Weight",
  //   //   dataIndex: "plannedweight",
  //   //   width: "9%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
  //   // },
  //   // {
  //   //   title: "Core ID",
  //   //   dataIndex: "coreid",
  //   //   width: "6%",
  //   //   render: (text, record) =>
  //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
  //   // },
  //   // {
  //   //   title: "Reel OD",
  //   //   dataIndex: "reelod",
  //   //   width: "6%",
  //   //   render: (text, record, index) => (
  //   //     <Styled>
  //   //       <div style={{ display: "flex" }}>
  //   //         {record.id_od_type == "range" && (
  //   //           <div
  //   //             style={{
  //   //               color: "var(--para-text)",
  //   //               display: "flex",
  //   //               width: "100%",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.minimum_reel_od +
  //   //               "-" +
  //   //               record.maximum_reel_od +
  //   //               " " +
  //   //               lengthUnit[record.units.maximum_reel_od].displayName}
  //   //           </div>
  //   //         )}
  //   //         {record.id_od_type == "constant" && (
  //   //           <div
  //   //             style={{
  //   //               display: "flex",
  //   //               width: "70%",
  //   //               flexDirection: "column",
  //   //               alignSelf: "center",
  //   //             }}
  //   //           >
  //   //             {record.reelod &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 return (
  //   //                   index < 2 && (
  //   //                     <div>
  //   //                       {item}{" "}
  //   //                       {index == 1
  //   //                         ? "...,"
  //   //                         : record.reelod.length > 1
  //   //                         ? ","
  //   //                         : ""}
  //   //                     </div>
  //   //                   )
  //   //                 );
  //   //               })}

  //   //             {record.reelod &&
  //   //               record.reelod?.length >= 2 &&
  //   //               record.reelod?.map((item, index) => {
  //   //                 let tooltipData = "";
  //   //                 for (
  //   //                   let index = 2;
  //   //                   index < record.reelod?.length;
  //   //                   index++
  //   //                 ) {
  //   //                   const data = record.reelod[index];
  //   //                   tooltipData = tooltipData + data + ", ";
  //   //                 }
  //   //                 tooltipData = tooltipData.substring(
  //   //                   0,
  //   //                   tooltipData.length - 1
  //   //                 );
  //   //                 return (
  //   //                   index == 2 && (
  //   //                     <Tooltip title={tooltipData}>
  //   //                       {" "}
  //   //                       <span
  //   //                         style={{
  //   //                           display: "flex",
  //   //                           fontSize: "10px",
  //   //                           fontWeight: "bold",
  //   //                         }}
  //   //                       >
  //   //                         & {record.reelod.length - 2} More
  //   //                       </span>
  //   //                     </Tooltip>
  //   //                   )
  //   //                 );
  //   //               })}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </Styled>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Rewinder Reels",
  //   //   dataIndex: "rewinder_reels",
  //   //   width: "9%",
  //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
  //   // },
  //   // {
  //   //   title: "QUO.PRICE",
  //   //   dataIndex: "price",
  //   //   width: "8%",
  //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
  //   // },
  //   {
  //     title: "Price",
  //     dataIndex:"netprice",
  //     width: "8%",
  //     render: (text, record) => (
  //       <Styled>
  //         {record.category === "SO" ? (
  //           "-"
  //         ) : (
  //           <>
  //             {record.type !== "reel" &&
  //               record.quantity_type !== "reel_sheet" && (
  //                 <span style={{ fontSize: "10px" }}>{record.netprice}</span>
  //               )}
  //             <br />
  //             <span style={{ textAlign: "center" }}>
  //               Rate: {record.dealerPrice}
  //             </span>
  //           </>
  //         )}
  //       </Styled>
  //     ),
  //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //     // sortOrder: "null",
  //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "7.3%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
  //     },
  //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
  //   },

  //   {
  //     title: "Approved By",
  //     dataIndex: "approvedby",
  //     width: "6.4%",
  //     align: "center",
  //     render: (text, record) =>
  //       record.status === "Open" || record.status === "Pending" ? "-" : text,
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "6%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     width: "7.6%",
  //     render: (text, record) => (
  //       <div className="statusVal" dataval={record.status}>
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               record.status === "Changes Req"
  //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
  //                 : record.status === "Approved"
  //                 ? "The order has been approved"
  //                 : record.status === "Pending"
  //                 ? "The order is pending for approval"
  //                 : record.status === "Open"
  //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
  //                 : record.status === "Rejected"
  //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
  //                 : record.status === "On Hold"
  //                 ? "The order has been put on hold by the approver"
  //                 : record.status === "Cancelled"
  //                 ? "The order has been cancelled"
  //                 : record.status === "Merged"
  //                 ? "The quantity in this order is merged with other orders"
  //                 : record.status === "Complete"
  //                 ? "The order has been produced"
  //                 : null
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {" "}
  //             {record.status === "In_production" ? "Approved" : record.status}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "6.8%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" && record?.quantity_type === "weight")
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight +
  //             record?.progressbar_info?.in_production?.weight) /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //             (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.completed?.units?.weight
  //                   ].displayName
  //                 )} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
  //                                 3
  //                               )
  //                             : 0.0
  //                         } ${capitalize(
  //                   weightUnit[
  //                     record?.progressbar_info?.in_production?.units?.weight
  //                   ].displayName
  //                 )} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
  //                               3
  //                             )
  //                           : 0.0
  //                       } ${capitalize(
  //                   weightUnit[record?.progressbar_info?.pending?.units?.weight]
  //                     .displayName
  //                 )} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity +
  //             record?.progressbar_info?.in_production?.quantity) /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed =
  //           (record?.progressbar_info?.completed?.quantity /
  //             (record?.no_of_reel_sheet -
  //               record.cancelled_quantity?.quantity)) *
  //           100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? record?.progressbar_info?.completed?.quantity
  //                     : 0
  //                 } Reels produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                             ? record?.progressbar_info?.in_production
  //                                 ?.quantity
  //                             : 0
  //                         } Reels in production
  //                         ${
  //                           record?.progressbar_info?.pending
  //                             ? record?.progressbar_info?.pending?.quantity
  //                             : 0
  //                         } Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }
  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "10%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"Release this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button onClick={() => handleApprove(record)}>
  //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //         {/* <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View Production Details"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleViewProdDetailsAction(record);
  //               }}
  //             >
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </Tooltip>
  //         </Styled> */}
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               {(userDetails.roles.approve_orders ||
  //                 (userDetails.roles.approve_orders &&
  //                   userDetails.id == record.user)) &&
  //                 record?.status == "Approved" &&
  //                 !record?.priority &&
  //                 record?.pendingQuantityValue != 0 && (
  //                   <Menu.Item key="1" style={{ padding: "0px 12px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => {
  //                         handleSplitAction(record);
  //                       }}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "8px" }}>
  //                           <Iconmoon
  //                             icon={"Mapping"}
  //                             size={17}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                           Split this order
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {record.status !== "Cancelled" &&
  //                 record?.split_type != "auto" &&
  //                 record.split_group &&
  //                 record.status == "Approved" &&
  //                 !record?.priority &&
  //                 record.completed == 0 &&
  //                 record.in_production == 0 &&
  //                 record.in_process == 0 &&
  //                 record.parent && (
  //                   <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
  //                     <DisabledButtonStyle>
  //                       <Button
  //                         style={{
  //                           border: "none",
  //                           background: "none",
  //                           padding: "0",
  //                           font: "inherit",
  //                           textAlign: "left",
  //                           width: "100%",
  //                           color: "black",
  //                         }}
  //                         className="themeBtn noBg"
  //                         onClick={() => onMergeOrderHandler(record, "menuEle")}
  //                       >
  //                         <div
  //                           style={{ display: "flex", flexDirection: "row" }}
  //                         >
  //                           <div style={{ marginTop: "-1px" }}>
  //                             <Iconmoon
  //                               icon={"export"}
  //                               size={14}
  //                               color="#605E5C"
  //                             />{" "}
  //                           </div>
  //                           <div
  //                             style={{ marginTop: "-3px", marginLeft: "11px" }}
  //                           >
  //                             Merge order
  //                           </div>
  //                         </div>
  //                       </Button>
  //                     </DisabledButtonStyle>
  //                   </Menu.Item>
  //                 )}
  //               {record.status == "Approved" &&
  //                 record.pendingQuantityValue > 0 && (
  //                   <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
  //                     <Button
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                       onClick={() => handleCancelledQuantityAction(record)}
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Quantity
  //                         </div>
  //                       </div>
  //                     </Button>
  //                   </Menu.Item>
  //                 )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="4" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProdDetailsAction(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"production"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Production Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {["On Hold", "Approved"].includes(record?.status) && (
  //                 <Menu.Item key="5" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewProcessedQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Processed Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               {[
  //                 "On Hold",
  //                 "Approved",
  //                 "Open",
  //                 "Changes Req",
  //                 "Pending",
  //               ].includes(record?.status) && (
  //                 <Menu.Item key="6" style={{ padding: "0px 12px" }}>
  //                   <Button
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                     onClick={() => {
  //                       handleViewPendingQtyDetails(record);
  //                     }}
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "8px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "5px", marginLeft: "6px" }}>
  //                         View Pending Quantity Details
  //                       </div>
  //                     </div>
  //                   </Button>
  //                 </Menu.Item>
  //               )}
  //               <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewPODetailsHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"viewPODetails"}
  //                           size={17}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                         {record.category === "PO"
  //                           ? "View PO Details"
  //                           : "View SO Details"}
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
  //                 <DisabledButtonStyle>
  //                   <Button
  //                     onClick={() => {
  //                       onViewChangeHandler(record);
  //                     }}
  //                     style={{
  //                       border: "none",
  //                       background: "none",
  //                       padding: "0",
  //                       font: "inherit",
  //                       textAlign: "left",
  //                       width: "100%",
  //                       color: "black",
  //                     }}
  //                     className="themeBtn noBg"
  //                   >
  //                     <div style={{ display: "flex", flexDirection: "row" }}>
  //                       <div style={{ marginTop: "0px" }}>
  //                         <Iconmoon
  //                           icon={"changeHistory"}
  //                           size={19}
  //                           color="#605E5C"
  //                         />{" "}
  //                       </div>
  //                       <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
  //                         View Change History
  //                       </div>
  //                     </div>
  //                   </Button>{" "}
  //                 </DisabledButtonStyle>
  //               </Menu.Item>

  //               {(record.status == "Approved" &&
  //                 record.processQuantity?.split(" ")[0] == 0) ||
  //               record.status == "On Hold" ||
  //               record.status == "Pending" ||
  //               record.status == "Changes Req" ||
  //               record.status == "Rejected" ? (
  //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
  //                   <DisabledButtonStyle>
  //                     <Button
  //                       onClick={() => handleCancel(record)}
  //                       style={{
  //                         border: "none",
  //                         background: "none",
  //                         padding: "0",
  //                         font: "inherit",
  //                         textAlign: "left",
  //                         width: "100%",
  //                         color: "black",
  //                       }}
  //                       className="themeBtn noBg"
  //                     >
  //                       <div style={{ display: "flex", flexDirection: "row" }}>
  //                         <div style={{ marginTop: "0px" }}>
  //                           <Iconmoon
  //                             icon={"wrong"}
  //                             size={15}
  //                             color="#605E5C"
  //                           />{" "}
  //                         </div>
  //                         <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
  //                           Cancel Order
  //                         </div>
  //                       </div>
  //                     </Button>{" "}
  //                   </DisabledButtonStyle>
  //                 </Menu.Item>
  //               ) : (
  //                 ""
  //               )}
  //             </Menu>
  //           }
  //           placement="bottom"
  //           arrow
  //         >
  //           <DisabledButtonStyle>
  //             <Button>
  //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
  //             </Button>
  //           </DisabledButtonStyle>
  //         </Dropdown>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);

  const columnBlacklist = settingsData?.settings?.orders_page?.tables?.approve_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";
  const fullColumnsPendingHead = [
    // {
    //   title: "Select",
    //   dataIndex: "checked",
    //   width: "8%",
    //   fixed: "left",
    //   align: "center",
    //   render: (value, record, rowIndex) => (
    //     <Styled>
    //       <Checkbox
    //         checked={value}
    //         onChange={handleCheckboxChangeFactory(
    //           rowIndex,
    //           "checked",
    //           tableData,
    //           setTableData,
    //           setSelectedPendingOrders,
    //           record
    //         )}
    //       />
    //     </Styled>
    //   ),
    // },
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "20%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Approve this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleApprove(record)}>
                <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Reject this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                disabled={record.priority}
                onClick={() => handleReject(record.orderno)}
              >
                <Iconmoon icon="wrong-file" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Request changes in this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleChangeRequest(record.orderno)}>
                <Iconmoon icon="refresh" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          <Dropdown
            overlay={
              <Menu>
                {(userDetails.roles.approve_orders ||
                  (userDetails.roles.approve_orders &&
                    userDetails.id == record.user)) &&
                  record?.status == "Active" &&
                  !record?.priority &&
                  record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                    <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleSplitAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"Mapping"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            Split this order
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {record.status !== "Cancelled" &&
                  record?.split_type != "auto" &&
                  record.split_group &&
                  record.status == "Active" &&
                  !record?.priority &&
                  record.completed == 0 &&
                  record.in_production == 0 &&
                  record.in_process == 0 &&
                  record.parent && record.isEditAllowed && (
                    <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => onMergeOrderHandler(record, "menuEle")}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "-1px" }}>
                              <Iconmoon
                                icon={"export"}
                                size={14}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-3px", marginLeft: "11px" }}
                            >
                              Merge order
                            </div>
                          </div>
                        </Button>
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                {record.status == "Active" &&
                  record.pendingQuantityValue > 0 && record.isEditAllowed && (
                    <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => handleCancelledQuantityAction(record)}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Quantity
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {["On Hold", "Approved"].includes(record?.status) && (
                  <Menu.Item key="4" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"production"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Production Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {["On Hold", "Approved"].includes(record?.status) && (
                  <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProcessedQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Processed Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {[
                  "On Hold",
                  "Approved",
                  "Open",
                  "Changes Req",
                  "Pending",
                ].includes(record?.status) && (
                  <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewPendingQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Pending Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewPODetailsHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                          {record.category === "PO"
                            ? "View PO Details"
                            : "View SO Details"}
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewChangeHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"changeHistory"}
                            size={19}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                          View Change History
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                {(record.status == "Active" &&
                  record.processQuantity?.split(" ")[0] == 0) ||
                record.status == "On Hold" ||
                record.status == "Pending Confirmation" ||
                record.status == "Changes Requested" ||
                record.status == "Confirmation Rejected" && record.isEditAllowed ? (
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => handleCancel(record)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Order
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                ) : (
                  ""
                )}
              </Menu>
            }
            placement="bottom"
            arrow
          >
            <DisabledButtonStyle>
              <Button>
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </DisabledButtonStyle>
          </Dropdown>
        </div>
      ),
      align: "center",
    },
  ];

  const fullColumnsChangesReqHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Approve this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleApprove(record)}>
                <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Reject this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                disabled={record.priority}
                onClick={() => handleReject(record.orderno)}
              >
                <Iconmoon icon="wrong-file" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled> */}
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Request changes in this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={showOrderChangeRequestDrawer}>
                <Iconmoon icon="refresh" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          <Dropdown
            overlay={
              <Menu>
                {(userDetails.roles.approve_orders ||
                  (userDetails.roles.approve_orders &&
                    userDetails.id == record.user)) &&
                  record?.status == "Active" &&
                  !record?.priority &&
                  record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                    <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleSplitAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"Mapping"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            Split this order
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {record.status !== "Cancelled" &&
                  record?.split_type != "auto" &&
                  record.split_group &&
                  record.status == "Active" &&
                  !record?.priority &&
                  record.completed == 0 &&
                  record.in_production == 0 &&
                  record.in_process == 0 &&
                  record.parent && record.isEditAllowed && (
                    <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => onMergeOrderHandler(record, "menuEle")}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "-1px" }}>
                              <Iconmoon
                                icon={"export"}
                                size={14}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-3px", marginLeft: "11px" }}
                            >
                              Merge order
                            </div>
                          </div>
                        </Button>
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                {record.status == "Active" &&
                  record.pendingQuantityValue > 0 && record.isEditAllowed && (
                    <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => handleCancelledQuantityAction(record)}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Quantity
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="4" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"production"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Production Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProcessedQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Processed Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {[
                  "On Hold",
                  "Active",
                  "Provisional",
                  "Changes Requested",
                  "Pending Confirmation",
                ].includes(record?.status) && (
                  <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewPendingQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Pending Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewPODetailsHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                          {record.category === "PO"
                            ? "View PO Details"
                            : "View SO Details"}
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewChangeHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"changeHistory"}
                            size={19}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                          View Change History
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                {(record.status == "Active" &&
                  record.processQuantity?.split(" ")[0] == 0) ||
                record.status == "On Hold" ||
                record.status == "Pending Confirmation" ||
                record.status == "Changes Requested" ||
                record.status == "Confirmation Rejected" && record.isEditAllowed  ? (
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => handleCancel(record)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Order
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                ) : (
                  ""
                )}
              </Menu>
            }
            placement="bottom"
            arrow
          >
            <DisabledButtonStyle>
              <Button>
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </DisabledButtonStyle>
          </Dropdown>
        </div>
      ),
      align: "center",
    },
  ];

  const fullColumnsApprovedHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "16%",
      render: (text, record) =>
        record.item_type === "order" ? (
          <div className="actionBtn">
            {record.isEditAllowed && 
            <>
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={
                  record.priority ? "Remove priority" : "Prioritize this order"
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handlePrioritize(record);
                  }}
                >
                  <Iconmoon
                    icon={record.priority ? "low-priority" : "high-priority"}
                    size={16}
                    color={record.priority ? "#ea4e2c" : "#3fbd61"}
                  />
                </Button>
                {/* Based on the priority change icon name as "high-priority" and "low-priority" and change the color code as "#3fbd61" and "#3fbd61" */}
              </Tooltip>
            </Styled>
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Hold this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  disabled={record.priority}
                  onClick={() => handleHold(record.orderno)}
                >
                  <Iconmoon icon="hold" size={16} color="#ea4e2c" />
                </Button>
                {/* Based on the Hold status change the color code as "#ea4e2c" and "#3fbd61" */}
              </Tooltip>
            </Styled>
            </>}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleViewAction(record);
                  }}
                >
                  <Iconmoon icon="file-view" size={16} color="#605E5C" />
                </Button>
              </Tooltip>
            </Styled>
            {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
            <Dropdown
              overlay={
                <Menu>
                  {(userDetails.roles.approve_orders ||
                    (userDetails.roles.approve_orders &&
                      userDetails.id == record.user)) &&
                    record?.status == "Active" &&
                    !record?.priority &&
                    record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                      <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleSplitAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"Mapping"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              Split this order
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  {record.status !== "Cancelled" &&
                    record?.split_type != "auto" &&
                    record.split_group &&
                    record.status == "Active" &&
                    !record?.priority &&
                    record.completed == 0 &&
                    record.in_production == 0 &&
                    record.in_process == 0 &&
                    record.parent && record.isEditAllowed &&(
                      <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              onMergeOrderHandler(record, "menuEle")
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "-1px" }}>
                                <Iconmoon
                                  icon={"export"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{
                                  marginTop: "-3px",
                                  marginLeft: "11px",
                                }}
                              >
                                Merge order
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                  {record.status == "Active" &&
                    record.pendingQuantityValue > 0 && record.isEditAllowed && (
                      <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => handleCancelledQuantityAction(record)}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"wrong"}
                                size={15}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              Cancel Quantity
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  {["On Hold", "Active"].includes(record?.status) && (
                    <Menu.Item key="4" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleViewProdDetailsAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"production"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            View Production Details
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                  {["On Hold", "Active"].includes(record?.status) && (
                    <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleViewProcessedQtyDetails(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"viewPODetails"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            View Processed Quantity Details
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                  {[
                    "On Hold",
                    "Active",
                    "Provisional",
                    "Changes Requested",
                    "Pending Confirmation",
                  ].includes(record?.status) && (
                    <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleViewPendingQtyDetails(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"viewPODetails"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            View Pending Quantity Details
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                  <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => {
                          onViewPODetailsHandler(record);
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"viewPODetails"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            {record.category === "PO"
                              ? "View PO Details"
                              : "View SO Details"}
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>

                  <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => {
                          onViewChangeHandler(record);
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"changeHistory"}
                              size={19}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                            View Change History
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>

                  {(record.status == "Active" &&
                    record.processQuantity?.split(" ")[0] == 0) ||
                  record.status == "On Hold" ||
                  record.status == "Pending Confirmation" ||
                  record.status == "Changes Requested" ||
                  record.status == "Confirmation Rejected" && record.isEditAllowed ? (
                    <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => handleCancel(record)}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"wrong"}
                                size={15}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              Cancel Order
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  ) : (
                    ""
                  )}
                </Menu>
              }
              placement="bottom"
              arrow
            >
              <DisabledButtonStyle>
                <Button>
                  <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                </Button>
              </DisabledButtonStyle>
            </Dropdown>
          </div>
        ) : (
          "-"
        ),
      align: "center",
    },
  ];

  const fullColumnsRejectedHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "12%",
      render: (text, record) => (
        <div className="actionBtn">
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Release this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleApprove(record)}>
                <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item key="1" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewPODetailsHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                          {record.category === "PO"
                            ? "View PO Details"
                            : "View SO Details"}
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewChangeHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"changeHistory"}
                            size={19}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                          View Change History
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                {(record.status == "Active" &&
                  record.processQuantity?.split(" ")[0] == 0) ||
                record.status == "On Hold" ||
                record.status == "Pending Confirmation" ||
                record.status == "Changes Requested" ||
                record.status == "Confirmation Rejected" &&record.isEditAllowed ? (
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => handleCancel(record)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Order
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                ) : (
                  ""
                )}
              </Menu>
            }
            placement="bottom"
            arrow
          >
            <DisabledButtonStyle>
              <Button>
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </DisabledButtonStyle>
          </Dropdown>
        </div>
      ),
      align: "center",
    },
  ];

  const fullColumnsOnHoldHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "12%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Release this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleApprove(record)}>
                <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Dropdown
            overlay={
              <Menu>
                {(userDetails.roles.approve_orders ||
                  (userDetails.roles.approve_orders &&
                    userDetails.id == record.user)) &&
                  record?.status == "Active" &&
                  !record?.priority &&
                  record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                    <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleSplitAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"Mapping"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            Split this order
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {record.status !== "Cancelled" &&
                  record?.split_type != "auto" &&
                  record.split_group &&
                  record.status == "Active" &&
                  !record?.priority &&
                  record.completed == 0 &&
                  record.in_production == 0 &&
                  record.in_process == 0 &&
                  record.parent && record.isEditAllowed && (
                    <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => onMergeOrderHandler(record, "menuEle")}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "-1px" }}>
                              <Iconmoon
                                icon={"export"}
                                size={14}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-3px", marginLeft: "11px" }}
                            >
                              Merge order
                            </div>
                          </div>
                        </Button>
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                {record.status == "Active" &&
                  record.pendingQuantityValue > 0 && record.isEditAllowed && (
                    <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => handleCancelledQuantityAction(record)}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Quantity
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="4" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"production"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Production Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProcessedQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Processed Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {[
                  "On Hold",
                  "Active",
                  "Open",
                  "Changes Requested",
                  "Pending Confirmation",
                ].includes(record?.status) && (
                  <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewPendingQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Pending Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewPODetailsHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                          {record.category === "PO"
                            ? "View PO Details"
                            : "View SO Details"}
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewChangeHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"changeHistory"}
                            size={19}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                          View Change History
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                {(record.status == "Active" &&
                  record.processQuantity?.split(" ")[0] == 0) ||
                record.status == "On Hold" ||
                record.status == "Pending Confirmation" ||
                record.status == "Changes Requested" ||
                record.status == "Confirmation Rejected" && record.isEditAllowed ? (
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => handleCancel(record)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Order
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                ) : (
                  ""
                )}
              </Menu>
            }
            placement="bottom"
            arrow
          >
            <DisabledButtonStyle>
              <Button>
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </DisabledButtonStyle>
          </Dropdown>
        </div>
      ),
      align: "center",
    },
  ];

  const fullColumnsCompleteHead = [
    {
      title: "Po/So .No",
      dataIndex: "pono",
      width: "8.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            {`#${record.category === "PO" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`}
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => {},
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
          record?.previous_state?.new &&
          (record?.previous_state?.old === "review" ||
            record?.previous_state?.old === "approved" ||
            record?.previous_state?.old === "cancel") &&
          record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                    ? "This order has been sent for approval again. This order was cancelled previously."
                    : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => {
          const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
          const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
          return dateA - dateB;
        },
      },
      render: (text, record) =>
        record.category === "SO" ? record.sodate : record.podate,
    },
    { title: "Category", dataIndex: "category", width: "7%", align: "left" },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                `The product specification is in the format of ${format}`
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "10.8%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
          record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text} `
          : "-",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
          ? `${text}`
          : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      dataIndex:"netprice",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "SO" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approved By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "6%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                  ? "The order has been approved"
                  : (record.status === "Pending" || record.status === "Pending Confirmation")
                  ? "The order is pending for approval"
                  : (record.status === "Open" || record.status === "Provisional")
                  ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                  : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                  ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                  : record.status === "On Hold"
                  ? "The order has been put on hold by the approver"
                  : record.status === "Cancelled"
                  ? "The order has been cancelled"
                  : record.status === "Merged"
                  ? "The quantity in this order is merged with other orders"
                  : record.status === "Produced"
                  ? "The order has been produced"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                  } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.completed?.units?.weight
                    ].displayName
                  )} Weight produced
                          ${
                            record?.progressbar_info?.in_production
                              ? (record?.progressbar_info?.in_production?.weight).toFixed(
                                  3
                                )
                              : 0.0
                          } ${capitalize(
                    weightUnit[
                      record?.progressbar_info?.in_production?.units?.weight
                    ].displayName
                  )} Weight in production
                        ${
                          record?.progressbar_info?.pending
                            ? (record?.progressbar_info?.pending?.weight).toFixed(
                                3
                              )
                            : 0.0
                        } ${capitalize(
                    weightUnit[record?.progressbar_info?.pending?.units?.weight]
                      .displayName
                  )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${
                    record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                  } Reels produced
                          ${
                            record?.progressbar_info?.in_production
                              ? record?.progressbar_info?.in_production
                                  ?.quantity
                              : 0
                          } Reels in production
                          ${
                            record?.progressbar_info?.pending
                              ? record?.progressbar_info?.pending?.quantity
                              : 0
                          } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Release this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleApprove(record)}>
                <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          {/* <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
          <Dropdown
            overlay={
              <Menu>
                {(userDetails.roles.approve_orders ||
                  (userDetails.roles.approve_orders &&
                    userDetails.id == record.user)) &&
                  record?.status == "Active" &&
                  !record?.priority &&
                  record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                    <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleSplitAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"Mapping"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            Split this order
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {record.status !== "Cancelled" &&
                  record?.split_type != "auto" &&
                  record.split_group &&
                  record.status == "Active" &&
                  !record?.priority &&
                  record.completed == 0 &&
                  record.in_production == 0 &&
                  record.in_process == 0 &&
                  record.parent && record.isEditAllowed && (
                    <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => onMergeOrderHandler(record, "menuEle")}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "-1px" }}>
                              <Iconmoon
                                icon={"export"}
                                size={14}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-3px", marginLeft: "11px" }}
                            >
                              Merge order
                            </div>
                          </div>
                        </Button>
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                {record.status == "Active" &&
                  record.pendingQuantityValue > 0 && record.isEditAllowed && (
                    <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => handleCancelledQuantityAction(record)}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Quantity
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="4" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"production"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Production Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {["On Hold", "Active"].includes(record?.status) && (
                  <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProcessedQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Processed Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                {[
                  "On Hold",
                  "Active",
                  "Provisional",
                  "Changes Requested",
                  "Pending Confirmation",
                ].includes(record?.status) && (
                  <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                    <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewPendingQtyDetails(record);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "8px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                          View Pending Quantity Details
                        </div>
                      </div>
                    </Button>
                  </Menu.Item>
                )}
                <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewPODetailsHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"viewPODetails"}
                            size={17}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                          {record.category === "PO"
                            ? "View PO Details"
                            : "View SO Details"}
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                  <DisabledButtonStyle>
                    <Button
                      onClick={() => {
                        onViewChangeHandler(record);
                      }}
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color: "black",
                      }}
                      className="themeBtn noBg"
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ marginTop: "0px" }}>
                          <Iconmoon
                            icon={"changeHistory"}
                            size={19}
                            color="#605E5C"
                          />{" "}
                        </div>
                        <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                          View Change History
                        </div>
                      </div>
                    </Button>{" "}
                  </DisabledButtonStyle>
                </Menu.Item>

                {(record.status == "Active" &&
                  record.processQuantity?.split(" ")[0] == 0) ||
                record.status == "On Hold" ||
                record.status == "Pending Confirmation" ||
                record.status == "Changes Requested" ||
                record.status == "Confirmation Rejected" &&record.isEditAllowed ? (
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => handleCancel(record)}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"wrong"}
                              size={15}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            Cancel Order
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                ) : (
                  ""
                )}
              </Menu>
            }
            placement="bottom"
            arrow
          >
            <DisabledButtonStyle>
              <Button>
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </DisabledButtonStyle>
          </Dropdown>
        </div>
      ),
      align: "center",
    },
  ];

  const filteredColumns1 = fullColumnsPendingHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullColumnsChangesReqHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns3 = fullColumnsApprovedHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns4 = fullColumnsRejectedHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns5 = fullColumnsOnHoldHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns6 = fullColumnsCompleteHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsPendingHead = useRef(filteredColumns1);
  const columnsChangesReqHead = useRef(filteredColumns2);
  const columnsApprovedHead = useRef(filteredColumns3);
  const columnsRejectedHead = useRef(filteredColumns4);
  const columnsOnHoldHead = useRef(filteredColumns5);
  const columnsCompleteHead = useRef(filteredColumns6);

  const onMergeOrderHandler = (record, type) => {
    setSplitOrderSideDrawer(false);
    setMergeDrawer(true);
    setSelectedOrder(record);
  };

  const handleCancelledQuantityAction = (record) => {
    setSelectedOrder(record);
    setCancelQuantitySideDrawer(true);
  };

  const handleViewProdDetailsAction = (record) => {
    setSelectedOrder(record);
    showProductionDetailsDrawer();
  };

  const handleViewProcessedQtyDetails = (record) => {
    setSelectedOrder(record);
    setProcessedQtyDetailsSideDrawer(true);
  };

  const handleViewPendingQtyDetails = (record) => {
    setSelectedOrder(record);
    setPendingQtyDetailsSideDrawer(true);
  };

  const handleSplitAction = (record) => {
    setSelectedOrder(record);
    showNewSplitOrderDrawer();
  };

  const showNewSplitOrderDrawer = () => {
    setSplitOrderSideDrawer(true);
  };

  const onViewPODetailsHandler = (record) => {
    record?.category === "PO"
      ? history("../po-details", {
          state: {
            poNumber: record.savedPO,
            backKey: "approveOrders",
            customer:record.customercode
          },
        })
      : history("../so-details", {
          state: {
            soNumber: record.sono,
            backKey: "../approve-records",
            isView: true,
          },
        });
  };
  const onViewChangeHandler = (record) => {
    history("../history", {
      state: {
        order: {
          orderDetails: record,
          route: "../approve-records",
          defaultActiveKey: defaultActiveKey,
          defaultOrderState: orderState,
        },
        logType: "Order",
        name: record.orderno,
        searchText: "Search change in order property",
      },
    });
  };

  const fetchOrdersList = async (params, sort, state) => {
    try {
      let currentSortOrder = sort;
      if (location?.state?.defaultActiveKey) {
        currentSortOrder =
          state === "rejected" ||
          state === "pending" ||
          state === "review" ||
          state === "hold" ||
          state === "cancel"
            ? {
                sort_by: "updated_at",
                sort_type: "descending",
              }
            : {
                sort_by: "po__date",
                sort_type: "descending",
              };
      }
      const allOrdersData = await getApprovedOrdersList(
        params,
        currentSortOrder,
        state
      );
      if (allOrdersData?.state === currentState.current) {
        if (!allOrdersData.orders.length) {
          setEmptyStateLabel("noData");
        }
        setPOCount(allOrdersData.total_po);
        setSOCount(allOrdersData.total_so);
        setTotalRecords(
          allOrdersData.page_size
            ? allOrdersData.page_size
            : allOrdersData.total_orders
        );
        // if (orderState) {
        //   setAllOrdersList(allOrdersData);
        // } else
        setAllOrdersList(allOrdersData.orders);
        setPageLoaded(false);
        setOrderWeightCount(allOrdersData.total_orders_quantity.toFixed(3));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setEmptyStateLabel("connectionAPIError");
      console.log(error);
    }
  };

  const fetchFilteredOrders = () => {
    // paginationRef.current = {
    //   page: 1,
    //   size: 10
    // }
    // setPageLoaded(false);
    getFilteredApproveOrders(
      appliedFilters,
      paginationRef.current,
      sortParams,
      orderState,
      showPriorityOrders
    )
      .then((response) => {
        setPageLoaded(false);
        setEmptyStateLabel("filter");
        setTotalRecords(
          response.data.page_size
            ? response.data.page_size
            : response.data.total_orders
        );
        setAllOrdersList(response.data.orders);
        setPOCount(response.data.total_po);
        setSOCount(response.total_so);

        setOrderWeightCount(response.data.total_orders_quantity.toFixed(3));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const onChange = async (pagination, filters, sorter, extra) => {
    setTableData([]);
    setLoading(true);
    sorterRef.current = { field: sorter?.field, order: sorter.order };
    if (currentState.current === "pending") {
      columnsPendingHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (currentState.current === "review") {
      columnsChangesReqHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (currentState.current === "approved") {
      columnsApprovedHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsRejectedHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (currentState.current === "hold") {
      columnsOnHoldHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    if (currentState.current === "complete") {
      columnsCompleteHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
    }
    const currentSorter = sorter.order
      ? {
          sort_by:
            sorter.field === "pono"
              ? "po"
              : sorter.field === "orderno"
              ? "id"
              : sorter.field === "createddate"
              ? "created_at"
              : sorter.field === "deliverydate"
              ? "delivery_date"
              : sorter.field === "groupno"
              ? "split_group"
              : orderState === "rejected" ||
                orderState === "pending" ||
                orderState === "review" ||
                orderState === "hold" ||
                orderState === "cancel"
              ? "updated_at"
              : "po__date",
          sort_type: sorter.order === "ascend" ? "ascending" : "descending",
        }
      : orderState === "rejected" ||
        orderState === "pending" ||
        orderState === "review" ||
        orderState === "hold" ||
        orderState === "cancel"
      ? {
          sort_by: "updated_at",
          sort_type: "descending",
        }
      : {
          sort_by: "po__date",
          sort_type: "descending",
        };
    if (
      sorter.field &&
      (currentSorter.sort_type !== sortParams.sort_type ||
        currentSorter.sort_by !== sortParams.sort_by)
    ) {
      setSortParams(currentSorter);
      // setPageLoaded(false);
      setCurrentPage(pagination.current);
      setPaginationParams({
        page: pagination.current,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
      };
    } else {
      setCurrentPage(pagination.current);
      setPaginationParams({
        page: pagination.current,
        size: pagination.pageSize,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
      };
    }
    // console.log(sorter);
    setReFetch(true);
  };

  const applyfilter = (filter) => {
    setTableData([]);
    if (currentState.current === "pending") {
      columnsPendingHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "review") {
      columnsChangesReqHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "approved") {
      columnsApprovedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsRejectedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "hold") {
      columnsOnHoldHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "complete") {
      columnsCompleteHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    // setPaginationParams({
    //   page: 1,
    //   size: 10,
    // });
    // paginationRef.current = {
    //   page: 1,
    //   size: 10,
    // };
    //setCurrentPage(1);
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    setReFetch(true);
    setCurrentPage(1);

    paginationRef.current = {
      page: 1,
      size: 10,
    };
    setPaginationParams({
      page: 1,
      size: 10,
    });
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "consignee":
        const consigneeValue =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Consignee",
          operand: "equals",
          value: consigneeValue,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
            ? "Sheet"
            : "Reel or Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "po_date":
        let poDateOperand = "";
        let poDateValue = "";
        if (item.start_date === item.end_date) {
          poDateOperand = "-";
          poDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          poDateOperand = "between";
          poDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "PO date",
          operand: poDateOperand,
          value: poDateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` +
              (item.grades[0].qualities?.length
                ? `"(${item.grades[0].qualities.join()})"`
                : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
            ? "Length"
            : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
    }
    console.log("Item in format", item);
  };

  const removeFilter = (filter) => {
    setTableData([]);
    if (currentState.current === "pending") {
      columnsPendingHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "review") {
      columnsChangesReqHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "approved") {
      columnsApprovedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsRejectedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "hold") {
      columnsOnHoldHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "complete") {
      columnsCompleteHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setSearchValue("");
    setClearSearch(true);
    setLoading(true);
    setReFetch(true);
    setCurrentPage(1);

    paginationRef.current = {
      page: 1,
      size: 10,
    };
    setPaginationParams({
      page: 1,
      size: 10,
    });
  };

  const handlePo = (record) => {
    setSelectedOrder(record);
    goToPOPage(record);
  };

  const approveOrder = async (orderNo) => {
    await bulkChangeOrderState([{ order: orderNo, state: "approved" }])
      .then((response) =>
        setActionResponse({ error: response.error, msg: response.msg })
      )
      .catch((error) => {
        console.log(error);
        // setActionResponse({
        //   error: error.response.data.error,
        //   msg: error.response.data.msg,
        // });
      });
  };

  const prioritizeOrder = async (record) => {
    // console.log(record);
    await changeOrderPriority({
      order: record.orderno,
      prioritize: !record.priority,
    })
      .then((response) =>
        setActionResponse({ error: response.error, msg: response.msg })
      )
      .catch((error) => {
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        // console.log(error);
      });
  };

  const handleCheckboxChangeFactory =
    (rowIndex, columnKey, array, setArray, setSelection, record) => (event) => {
      setPageLoaded(false);
      let selectedRowIndex = array?.findIndex(
        (ele) => ele.orderno == record.orderno
      );
      const newCheckboxState = [...array];
      newCheckboxState[selectedRowIndex][columnKey] = event.target.checked;
      setArray(newCheckboxState);
      let orderList = selectedPendingOrders;
      if (!event.target.checked) {
        orderList = orderList.filter(
          (val) => val !== newCheckboxState[selectedRowIndex].orderno
        );
      }
      let filterData = array
        .filter((item) => item.checked == true)
        .map((item) => item.orderno);
      let unique = [...orderList, ...filterData];

      setSelection([...new Set(unique)]);
    };

    const handleSelect = (record, selected) => {
      setPageLoaded(false);
      let allKeys = [];
      let index;
      if (selected) {
        record.select = true;
        setSelectedPendingOrders((keys) => [...keys, record.key]);
        allKeys = [...selectedPendingOrders, record.key];
      } else {
        record.select = false;
        setSelectedPendingOrders((keys) => {
           index = keys.indexOf(record.key);
          return [...keys.slice(0, index), ...keys.slice(index + 1)];
        });
  
        allKeys = [
          ...selectedPendingOrders.slice(0, index),
          ...selectedPendingOrders.slice(index + 1),
        ];
  
       
      }
  
      
  
      const result = allKeys.filter((f) => tableData.some((d) => d.key == f));
  
      if (result.length === tableData.length) setIsAllSelected(true);
      else setIsAllSelected(false);
    };
  
    const toggleSelectAll = (e) => {
      // setSelectedRowKeys((keys) =>
      //   keys.length === tableData.length ? [] : tableData.map((r) => r.key)
      // );
      setPageLoaded(false);

      const newCheckboxState = [...tableData];
  
      if (!e.target.checked) {
        setIsAllSelected(false);
        newCheckboxState.forEach((item) => {
          item.select = false;
        });
        
        setSelectedPendingOrders(
          [...selectedPendingOrders.filter((f) => !tableData.some((d) => d.key == f))]
        );
      } else {
        setIsAllSelected(true);
        newCheckboxState.forEach((item) => {
          item.select = true;
        });
       
        
  
        let uniqueKeys = [
          ...new Set([
            ...selectedPendingOrders,
            ...tableData.map((item) => item.key),
          ]),
        ];
        setSelectedPendingOrders([...uniqueKeys]);
      }
  
      setTableData([...newCheckboxState]);
      //tableDataRef.current = newCheckboxState;
      
    };
  

  const searchApproveOrders = async (value = "") => {
    setTableData([]);
    setPageLoaded(false);
    if (currentState.current === "pending") {
      columnsPendingHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "review") {
      columnsChangesReqHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "approved") {
      columnsApprovedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsRejectedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "hold") {
      columnsOnHoldHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "complete") {
      columnsCompleteHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    setLoading(true);
    setSearchValue(value);
    if (value === "" || value === null) {
      fetchOrdersList(paginationRef.current, sortParams, orderState);
      setAppliedFilters([]);
      setFilterTags([]);
    } else {
      setClearSearch(false);
      searchApproveOrderRecords(value, orderState)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          setAllOrdersList(response.data);
          setTotalRecords(response.data.length);
          setPOCount(response.total_po);
          setSOCount(response.total_so);

          setOrderWeightCount(response.total_orders_quantity.toFixed(3));
        })
        .catch(
          (error) => console.log("Error in search of order records:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    }
  };

  const handleReject = (value) => {
    showRejectOrder();
    setOrderAction("reject");
    setSelectedOrderNo(value);
  };

  const handleApprove = (record) => {
    modalShow();
    setOrderAction(record.status === "On Hold" ? "release" : "approve");
    setSelectedOrder(record);
    console.log(record.orderno);
    setSelectedOrderNo(record.orderno);
  };

  const handleHold = (value) => {
    showHoldOrder();
    setOrderAction("hold");
    setSelectedOrderNo(value);
  };

  const handleChangeRequest = (value) => {
    showOrderChangeRequestDrawer();
    setSelectedOrderNo(value);
    setOrderAction("review");
  };

  const handleViewAction = (record) => {
    setSelectedOrder(record);
    showViewPendingTab();
  };

  // const handleViewProdDetailsAction = (record) => {
  //   setSelectedOrder(record);
  //   showProductionDetailsDrawer();
  // }

  const handlePrioritize = (record) => {
    priorityModalShow();
    setOrderAction(record.priority ? "removePriority" : "prioritize");
    setSelectedOrder(record);
    setSelectedOrderNo(record.orderno);
  };

  const showRejectOrder = () => {
    setRejectOrders(true);
  };

  const showOrderChangeRequestDrawer = () => {
    setOrderChangeRequestDrawer(true);
  };

  const showViewPendingTab = () => {
    setviewPendingDrawer(true);
  };

  const showProductionDetailsDrawer = () => {
    setProductionDetailsSideDrawer(true);
  };

  const onCloseAllDrawers = () => {
    setviewPendingDrawer(false);
    setResendApprovalData(false);
    setOrderChangeRequestDrawer(false);
    setRejectOrders(false);
    setHoldOrders(false);
    setProductionDetailsSideDrawer(false);
    setSplitOrderSideDrawer(false);
    setMergeDrawer(false);
    setCancelQuantitySideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    // setReFetch(true);
  };

  const onCloseApproveOrders = () => {
    setviewPendingDrawer(false);
    setResendApprovalData(false);
    setOrderChangeRequestDrawer(false);
    setHoldOrders(false);
    setProductionDetailsSideDrawer(false);
    setSplitOrderSideDrawer(false);
    setMergeDrawer(false);
    setCancelQuantitySideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
  };

  const handleCancel = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setHoldOrders(true);
    setOrderAction("cancel");
    setSelectedOrderNo(selectedOrder?.orderno);
    setviewPendingDrawer(false);
    setResendApprovalData(false);
    setOrderChangeRequestDrawer(false);
    setProductionDetailsSideDrawer(false);
    setSplitOrderSideDrawer(false);
    setMergeDrawer(false);
    setCancelQuantitySideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
  };

  const handleRestore = () => {
    setHoldOrders(true);
    setOrderAction("pending");
    setviewPendingDrawer(false);
    setResendApprovalData(true);
    setOrderChangeRequestDrawer(false);
  };

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = async (record) => {
    await approveOrder(record.orderno);
    setIsVisibleModal(false);
    console.log(orderAction);
    setReFetch(true);
    showToaster();
  };

  const priorityModalShow = () => {
    setIsVisiblePriorityModal(true);
  };

  const priorityModalClose = () => {
    setIsVisiblePriorityModal(false);
  };

  const refresh = () => {
    setLoading(true);
    setTableData();
    setPageLoaded(false);
    setSearchValue("");
    setClearSearch(true);
    setReFetch(true);
  };

  const priorityModalConfirm = async (value) => {
    await prioritizeOrder(value);
    setIsVisiblePriorityModal(false);
    setReFetch(true);
    showToaster();
  };

  const showHoldOrder = () => {
    setHoldOrders(true);
  };

  const showToaster = () => {
    setToaster(true);
    setTimeout(() => {
      setToaster(false);
      setSelectedPendingOrders([]);
    }, 2000);
  };

  const goToPOPage = (record) => {
    record
      ? record.category === "PO"
        ? history("../po-details", {
            state: {
              poNumber: record.savedPO,
              backKey: "approveOrders",
              customer: record.customercode,

            },
          })
        : history("../so-details", {
            state: {
              soNumber: record.sono,
              backKey: "../approve-records",
              isView: true,
            },
          })
      : selectedOrder?.category === "PO"
      ? history("../po-details", {
          state: {
            poNumber: selectedOrder.savedPO,
            backKey: "approveOrders",
              customer: record.customercode,

          },
        })
      : history("../so-details", {
          state: {
            soNumber: selectedOrder.sono,
            backKey: "../approve-records",
            isView: true,
          },
        });
    setviewPendingDrawer(false);
    setResendApprovalData(false);
    setProductionDetailsSideDrawer(false);
  };
  const handleOrder = (record) => {
    history("../order-details", {
      state: {
        values: {
          poNumber: record.pono,
          date: record.podate,
          customer: record.customercode,
        },
        route: "po-details",
        backKey: "approveOrders",
      },
    });
  };

  const exportHandler = () => {
    const currentDate = new Date();
    const today =
      currentDate.getDate() +
      "/" +
      currentDate.toLocaleString("default", { month: "long" }) +
      "/" +
      currentDate.getFullYear();
    let sp = sortParams;
    let fileName = orderState + "_orders_Kaiznn_" + today;
    if (appliedFilters.length) {
      let paginationParams = "";
      // let sortParams = "";
      history("../approve-records/export-orders", {
        state: {
          body: {
            status: orderState,
            searchValue: searchValue,
            paginationParams: paginationParams,
            sortParams: sp,
            appliedFilters: appliedFilters,
            page: "approve order records",
            type: "Filter",
          },
          rootPage: "../approve-records",
          fileName: fileName,
          count: totalRecords,
        },
      });
    } else if (!clearSearch && searchValue) {
      history("../approve-records/export-orders", {
        state: {
          body: {
            status: orderState,
            searchValue: searchValue,
            page: "approve order records",
            type: "Search",
          },
          rootPage: "../approve-records",
          fileName: fileName,
          count: totalRecords,
        },
      });
    } else {
      let paginationParams = "";
      // let sortParams = "";
      history("../approve-records/export-orders", {
        state: {
          body: {
            status: orderState,
            paginationParams: paginationParams,
            sortParams: sortParams,
            page: "approve order records",
            type: "All Data",
          },
          rootPage: "../approve-records",
          fileName: fileName,
          count: totalRecords,
        },
      });
    }
  };

  const getTableData = () =>
    allOrdersList.map((order) => {
      // let currencySymbol = currency_List.filter(currUnit => currUnit.code === order.units.net_price);
      // let currencySymbolForProd = currency_List.filter(item => item.code === order.product_info.units.price);
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (order.type == "reel" && order.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          order.this_item_type == "order"
            ? Math.round(order.total_pending_quantity.quantity)
            : Math.round(order.total_pending_quantity.quantity);
        processQuantity =
          order.this_item_type == "order"
            ? Math.round(order.total_processed_quantity.quantity) + " Reels"
            : Math.round(order.total_processed_quantity.quantity) + " Reels";
        pendingQuantity =
          order.this_item_type == "order"
            ? Math.round(order.total_pending_quantity.quantity) + " Reels"
            : Math.round(order.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          order.this_item_type == "order"
            ? Math.round(order.cancelled_quantity.quantity) + " Reels"
            : Math.round(order.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          order.this_item_type == "order"
            ? Math.round(order.no_of_reel_sheet) + " Reels"
            : Math.round(order.total_quantity) + " Reels";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
      } else if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
        quantityValue =
          order.this_item_type == "order"
            ? order.weight
              ? order.weight +
                " " +
                capitalize(weightUnit[order.units?.planned_weight].displayName)
              : "-"
            : order.total_weight
            ? order.total_weight +
              " " +
              capitalize(weightUnit[order.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
        processQuantity =
          order.this_item_type == "order"
            ? order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              )
            : order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              )
            : order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          order.this_item_type == "order"
            ? order.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[order.cancelled_quantity.units].displayName)
            : order.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight
            : order.total_pending_quantity.weight;
      } else if (
        (order.type == "reel" || order.type == "sheet") &&
        order.quantity_type == "weight"
      ) {
        quantityValue =
          order.this_item_type == "order"
            ? order.weight
              ? order.weight +
                " " +
                capitalize(weightUnit[order.units?.planned_weight].displayName)
              : "-"
            : order.total_weight
            ? order.total_weight +
              " " +
              capitalize(weightUnit[order.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
        processQuantity =
          order.this_item_type == "order"
            ? order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              )
            : order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              )
            : order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          order.this_item_type == "order"
            ? order.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[order.cancelled_quantity.units].displayName)
            : order.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight
            : order.total_pending_quantity.weight;
      }
      let currencySymbol;
      if (order.units.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === order.units.net_price
        );
      } else {
        currencySymbol = "";
      }

      let currencySymbolDealer;
      if (order?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === order.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }

      let currencySymbolForProd;
      if (order?.product_info.units.price) {
        currencySymbolForProd = currency_List.filter(
          (item) => item.code === order.product_info.units.price
        );
      } else {
        currencySymbolForProd = "";
      }

      let pendingValue;
      if (order.type === "sheet" && !order.core_id && !order.reel_od) {
        pendingValue =
          order.this_item_type == "order"
            ? order.pending_quantity_weight
            : order.total_planned_weight -
              order.total_weight_completed -
              order.total_weight_in_production -
              order.total_weight_in_process;
      } else {
        pendingValue =
          order.this_item_type == "order"
            ? order.quantity -
              order.completed -
              order.in_production -
              order.in_process
            : order.total_quantity -
              order.total_weight_completed -
              order.total_weight_in_production -
              order.total_weight_in_process;
      }
      return {
        select:
          selectedPendingOrders &&
          orderState === "pending" &&
          selectedPendingOrders.filter((e) => e === order.number).length > 0,
        key: order.number,
        isEditAllowed: orderManagementSettings?.edit_after_approval?.value,
        pono:
          order.po && typeof order.po === "string"
            ? order.po.toUpperCase()
            : order.po,
        sono:
          order.so && typeof order.so === "string"
            ? order.so.toUpperCase()
            : order.so,
        category: order.category.toUpperCase(),
        savedPO: order.po,
        orderno: order.number ? order.number : "-",
        createddate: moment(order.created_at).format("DD MMM YYYY"),
        podate: moment(order.po_date).format("DD MMM YYYY"),
        sodate: moment(order.so_date).format("DD MMM YYYY"),
        customername: order.customer_name,
        customercode: order.customer,
        productcode: order.product,
        product_spec: order.product_spec,
        type: order.type ? capitalize(order.type) : "-",
        size: order.width
          ? `${order.width}${order.length ? `x${order.length}` : ""} ${
              order.units
                ? lengthUnit[order.units?.width]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        units: order.units ? order.units : "",
        quantity: quantityValue,
        weight:
          order.this_item_type == "order"
            ? `${parseFloat(order.weight).toFixed(3)}`
            : `${parseFloat(order.total_weight).toFixed(3)}`,
        coreid: order.inner_dia ? `${order.inner_dia}` : "-",
        reelod: order.outer_dia ? `${order.outer_dia}` : "-",
        rewinderreels: order.quantity ? order.quantity + " Reels" : "-",
        productPrice: order?.product_info?.price
          ? `${
              order.product_info.units && currencySymbolForProd
                ? currencySymbolForProd[0].symbol
                : ""
            }` +
            " " +
            parseFloat(order?.product_info?.price).toFixed(2) +
            `${
              order?.product_info.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    order?.product_info.units?.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        price: order.quoted_price
          ? `${order.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(order.quoted_price).toFixed(2) +
            `${
              order?.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    order.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        netprice: order.net_price
          ? `${order.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(order.net_price).toFixed(2)
          : "-",
        dealerPrice: order.dealer_price
          ? `${
              order.units && currencySymbolDealer
                ? currencySymbolDealer[0].symbol
                : ""
            }` +
            " " +
            parseFloat(order.dealer_price).toFixed(3) +
            " " +
            `${
              order?.units?.per_weight_unit
                ? " / " +
                  weightUnit[
                    order.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        deliverydate:
          order.category === "so"
            ? "-"
            : order.delivery_date
            ? moment(order.delivery_date).format("DD MMM YYYY")
            : "-",
        createdBy: order.created_by ? order.created_by : "-",
        remarks: order.remarks ? order.remarks : "-",
        priority: order.forced,
        completed: order.completed,
        in_production:
          order.this_item_type == "order"
            ? order.in_production + order.in_process
            : order.total_in_production + order.total_in_process,
        // pending: order.this_item_type == 'order' ?
        //   order.quantity -
        //   order.completed -
        //   order.in_production -
        //   order.in_process
        // : order.total_quantity -
        //   order.total_completed -
        //   order.total_in_production -
        //   order.total_in_process,
        pending: pendingValue,
        // status: order.state ? order.state : '-',
        status:
          order.this_item_type == "order"
            ? capitalize(
                // order.state === "review"
                //   ? "changes Req"
                //   : order.state === "hold"
                //   ? "On Hold"
                //   : order.state === "in_production"
                //   ? "In Production"
                //   : order.state === "cancel"
                //   ? "Cancelled"
                //   : order.state
                order.state === "review"
                  ? "Changes Requested"
                  : order.state === "hold"
                  ? "On Hold"
                  : order.state === "in_production"
                  ? "In Production"
                  : order.state === "cancel"
                  ? "Cancelled"
                  : order.state == "open" 
                  ? "Provisional"
                  : order.state == "pending"
                  ? "Pending Confirmation" 
                  : order.state == "rejected"
                  ? "Confirmation Rejected"
                  : order.state == "approved"
                  ? "Active" 
                  : order.state == "produced"
                  ? "Produced"
                  : order.state
              )
            : "-",
        quantity_type: order.quantity_type ? order.quantity_type : "-",
        // no_of_reel_sheet: `${order.no_of_reel_sheet}`,
        plannedweight: order.planned_weight
          ? order.planned_weight != 0
            ? order.planned_weight.toFixed(3) +
              ` ${
                order.units && order.this_item_type === "order"
                  ? weightUnit[
                      order.units.planned_weight
                    ]?.displayName?.toUpperCase()
                  : weightUnit[
                      order.units.total_weight
                    ]?.displayName?.toUpperCase()
              }`
            : "-"
          : "-",
        item_type: order.this_item_type,
        groupno: order.this_item_type == "order" ? "-" : order.id,
        customer_alias: order.customer_alias,
        previous_state: order.previous_state,
        consignee_alias: order.consignee_alias,
        consignee: order.consignee,
        consignee_name: order.consignee_name,
        sheet_completed_weight: order.sheet_completed_weight
          ? order.sheet_completed_weight
          : 0,
        sheet_processed_weight: order.sheet_processed_weight
          ? order.sheet_processed_weight
          : 0,
        sheet_production_weight: order.sheet_production_weight
          ? order.sheet_production_weight
          : 0,
        pending_quantity_weight: order.pending_quantity_weight,
        total_weight_in_process: order.total_weight_in_process
          ? order.total_weight_in_process
          : 0,
        total_weight_in_production: order.total_weight_in_production
          ? order.total_weight_in_production
          : 0,
        total_weight_completed: order.total_weight_completed
          ? order.total_weight_completed
          : 0,
        cancelledQuantity,
        pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        // total_pending_quantity : item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: order.progressbar_info,
        no_of_sheets: order.no_of_sheets,
        no_of_reel_sheet: order.no_of_reel_sheet,
        cancelled_quantity: order.cancelled_quantity,
        split_type: order.split_type,
        split_group: order.split_group,
        approvedby: order.approved_by,
        ply: order.ply,
      };
    });

  const tabHeads = [
    {
      key: 0,
      title: "Pending Confirmation",
      state: "pending",
      header: columnsPendingHead.current,
    },
    {
      key: 1,
      title: "Changes Requested",
      state: "review",
      header: columnsChangesReqHead.current,
    },
    {
      key: 2,
      title: "Active",
      state: "approved",
      header: columnsApprovedHead.current,
    },
    {
      key: 3,
      title: "Confirmation Rejected",
      state: "rejected",
      header: columnsRejectedHead.current,
    },
    {
      key: 4,
      title: "Cancelled",
      state: "cancel",
      header: columnsRejectedHead.current,
    },
    {
      key: 5,
      title: "On Hold",
      state: "hold",
      header: columnsOnHoldHead.current,
    },
    {
      key: 6,
      title: "Produced",
      state: "complete",
      header: columnsCompleteHead.current,
    },
  ];

  const handleTabChange = (key) => {
    setPageLoaded(false);
    tableData.map((tableItem) => {
      tableItem["select"] = false;
    });
    if (currentState.current === "pending") {
      columnsPendingHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "review") {
      columnsChangesReqHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "approved") {
      columnsApprovedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (
      currentState.current === "rejected" ||
      currentState.current === "cancel"
    ) {
      columnsRejectedHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "hold") {
      columnsOnHoldHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    if (currentState.current === "complete") {
      columnsCompleteHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }

    setIsAllSelected(false);
    setSelectedPendingOrders([]);
    currentState.current = tabHeads[key].state;
    setTotalRecords("");
    setOrderWeightCount("");
    setDefaultActiveKey(key.toString());
    setLoading(true);
    setTableData([]);
    setPageLoaded(false);
    setFilterTags([]);
    setAppliedFilters([]);
    setSearchValue("");
    setClearSearch(true);
    setOrderState(tabHeads[key].state);
    setPaginationParams({
      page: 1,
      size: 10,
    });
    paginationRef.current = {
      page: 1,
      size: 10,
    };
    setCurrentPage(1);
    if (
      tabHeads[key].state === "rejected" ||
      tabHeads[key].state === "pending" ||
      tabHeads[key].state === "review" ||
      tabHeads[key].state === "hold" ||
      tabHeads[key].state === "cancel"
    ) {
      setSortParams({
        sort_by: "updated_at",
        sort_type: "descending",
      });
    } else {
      setSortParams({
        sort_by: "po__date",
        sort_type: "descending",
      });
    }
    setReFetch(true);
  };
useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
    const deckleMangSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangSettings?.data);
  }, []);
  useEffect(() => {
    (async () => {
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  useEffect(() => {
    if (
      reFetch &&
      !appliedFilters.length &&
      !showPriorityOrders &&
      searchValue == ""
    ) {
      fetchOrdersList(paginationRef.current, sortParams, orderState);
      setReFetch(false);
    } else if (
      reFetch &&
      (appliedFilters.length ||
        (showPriorityOrders && orderState === "approved"))
    ) {
      setLoading(true);
      fetchFilteredOrders();
      setReFetch(false);
    } else if (searchValue !== "" && reFetch) {
      setPageLoaded(false);
      searchApproveOrderRecords(searchValue, orderState)
        .then((response) => {
          setAllOrdersList(response.data);
          setPOCount(response.total_po);
          setSOCount(response.total_so);

          setTotalRecords(response.data.length);
          // setOrderWeightCount(response.data.total_orders_quantity.toFixed(3));
          setOrderWeightCount(
            response.total_orders_quantity
              ? response.total_orders_quantity.toFixed(3)
              : ""
          );
          setReFetch(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log("Error in search of order records:", error);
        });
    }
  }, [reFetch]);

  // useEffect(() => {
  //   setLoading(true);
  //   if (
  //     appliedFilters.length ||
  //     (showPriorityOrders && orderState === "approved")
  //   ) {
  //     // setLoading(true);
  //     fetchFilteredOrders();
  //   } else if (searchValue !== "") {
  //     setPageLoaded(false);
  //     searchApproveOrderRecords(searchValue, orderState)
  //       .then((response) => {
  //         setLoading(false);
  //         setAllOrdersList(response.data);
  //         setPOCount(response.total_po);
  //         setTotalRecords(response.data.length);
  //         // setOrderWeightCount(response.total_orders_quantity.toFixed(3));
  //         setOrderWeightCount(response.total_orders_quantity ? response.total_orders_quantity.toFixed(3) : "");

  //       })
  //       .catch((error) => {
  //         console.log("Error in search of order records:", error);
  //       });
  //   } else {
  //     fetchOrdersList(paginationRef.current, sortParams, orderState);
  //   }
  // }, [
  //   appliedFilters,
  //   sortParams,
  //   paginationParams,
  //   orderState,
  //   showPriorityOrders,
  // ]);

  useEffect(() => {
    let records = allOrdersList ? getTableData() : [];
    setTableData([...records]);
    const result = selectedPendingOrders.filter((f) => records.some((d) => d.key == f));

    if (result.length === records.length) setIsAllSelected(true);
    else setIsAllSelected(false);
    // setPageLoaded(false);
    // if( location?.state?.selectedOrder && !isStateData && allOrdersList.length)
    // {
    //   setDefaultActiveKey(location.state.defaultActiveKey)
    //   setStateData(true);
    //   setSelectedOrder(location.state.selectedOrder);
    //   // setviewPendingDrawer(true);
    //   history(location.pathname, {});
    // }
  }, [allOrdersList]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    if (!pageLoaded && tableData.length) {
      const filteredColumns1 = fullColumnsPendingHead.filter(
        (col) => !columnBlacklist.includes(col.dataIndex)
      );
      columnsPendingHead.current = filteredColumns1;

      // columnsPendingHead.current = [
      //   // {
      //   //   title: "Select",
      //   //   dataIndex: "checked",
      //   //   width: "8%",
      //   //   fixed: "left",
      //   //   align: "center",
      //   //   render: (value, record, rowIndex) => (
      //   //     <Styled>
      //   //       <Checkbox
      //   //         checked={value}
      //   //         onChange={handleCheckboxChangeFactory(
      //   //           rowIndex,
      //   //           "checked",
      //   //           tableData,
      //   //           setTableData,
      //   //           setSelectedPendingOrders,
      //   //           record
      //   //         )}
      //   //       />
      //   //     </Styled>
      //   //   ),
      //   // },
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "12.5%",
      //     fixed: "left",
      //     key: "pono",
      //     align: "left",
      //     sorter: () => {},
      //     // sortOrder: "null",
      //     // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      //     render: (text, record) => (
      //       <div className="">
      //         <Button
      //           style={{ background: "transparent" }}
      //           className="textTypeBtn textBtnIcon"
      //           onClick={() => handlePo(record)}
      //         >
      //           <div
      //             style={{
      //               whiteSpace: "normal",
      //               lineHeight: "1.2",
      //               textAlign: "left",
      //             }}
      //           >
      //             {`#${record.category === "PO" ? record.pono : record.sono}`
      //               .match(/.{1,15}/g)
      //               ?.map((chunk, index) => (
      //                 <span key={index}>
      //                   {chunk}
      //                   <br />
      //                 </span>
      //               ))}
      //           </div>
      //         </Button>
      //       </div>
      //     ),
      //   },
      //   // {
      //   //   title: "Group No",
      //   //   dataIndex: "groupno",
      //   //   width: "6.5%",
      //   //   fixed: "left",
      //   //   sorter: () => {},
      //   //   // sortOrder: "null",
      //   // },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     key: "orderno",
      //     width: "8%",
      //     fixed: "left",
      //     sorter: () => {},
      //     // sortOrder: "null",
      //     // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         {record?.previous_state?.old &&
      //         record?.previous_state?.new &&
      //         (record?.previous_state?.old === "review" ||
      //           record?.previous_state?.old === "approved" ||
      //           record?.previous_state?.old === "cancel") &&
      //         record.status === "Pending" ? (
      //           // <Styled >
      //           <TooltipSelector>
      //             <Tooltip
      //               overlayInnerStyle={{
      //                 borderRadius: "8px",
      //                 background: "rgba(32, 31, 30, 0.85)",
      //                 padding: "7px",
      //                 background: "rgba(32, 31, 30, 0.85)",
      //                 fontFamily: "var(--sf-pro-display-m)",
      //                 fontStyle: "normal",
      //                 fontSize: "12px",
      //                 lineHeight: "16px",
      //               }}
      //               placement="bottomRight"
      //               title={
      //                 record?.previous_state?.old === "review"
      //                   ? "This order has been sent for approval again. Changes were requested in this order previously."
      //                   : record?.previous_state?.old === "cancel"
      //                   ? "This order has been sent for approval again. This order was cancelled previously."
      //                   : "This order has been sent for approval again. This order was approved previously."
      //               }
      //               // getPopupContainer={(triggerNode) => triggerNode}
      //               overlayClassName="edit-tooltip"
      //             >
      //               <Button
      //                 style={{ background: "transparent" }}
      //                 className="textTypeBtn textBtnIcon"
      //                 onClick={() => handleViewAction(record)}
      //               >
      //                 {`${text}`}
      //               </Button>
      //             </Tooltip>
      //           </TooltipSelector>
      //         ) : text != "-" ? (
      //           // </Styled>
      //           <Button
      //             style={{ background: "transparent" }}
      //             className="textTypeBtn textBtnIcon"
      //             onClick={() => handleViewAction(record)}
      //           >
      //             {`${text}`}
      //           </Button>
      //         ) : (
      //           <span style={{ textAlign: "center" }}>{text}</span>
      //         )}
      //         {record?.previous_state?.old &&
      //           record?.previous_state?.new &&
      //           (record?.previous_state?.old === "review" ||
      //             record?.previous_state?.old === "approved" ||
      //             record?.previous_state?.old === "cancel") &&
      //           record.status === "Pending" && (
      //             <div>
      //               <span
      //                 style={{
      //                   color: "rgb(234, 101, 91)",
      //                   fontStyle: "italic",
      //                   fontSize: "10px",
      //                 }}
      //               >
      //                 Resent for approval
      //               </span>
      //             </div>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "PO/SO Date",
      //     dataIndex: "poDate",
      //     width: "7.3%",
      //     sorter: {
      //       compare: (a, b) => {
      //         const dateA = new Date(a.category === "SO" ? a.sodate : a.podate);
      //         const dateB = new Date(b.category === "SO" ? b.sodate : b.podate);
      //         return dateA - dateB;
      //       },
      //     },
      //     render: (text, record) =>
      //       record.category === "SO" ? record.sodate : record.podate,
      //   },
      //   {
      //     title: "Category",
      //     dataIndex: "category",
      //     width: "7%",
      //     align: "left",
      //   },
      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "7%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias || "-"}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "7%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias || "-"}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   // {
      //   //   title: "Prod. Code",
      //   //   dataIndex: "productcode",
      //   //   width: "5.8%",
      //   // },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //         <br />
      //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //       </Styled>
      //     ),
      //     //dataIndex: "productspec",
      //     width: "10.8%",
      //   },
      //   // {
      //   //   title: "Type",
      //   //   dataIndex: "type",
      //   //   width: "5.8%",
      //   // },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "8.4%",
      //   },
      //   {
      //     title: "PLY",
      //     dataIndex: "ply",
      //     width: "8.4%",
      //   },
      //   {
      //     title: "Order Quantity",
      //     dataIndex: "quantity",
      //     width: "7.4%",
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         {record.type.toLowerCase() == "sheet" &&
      //         record.quantity_type.toLowerCase() == "reel_sheet" ? (
      //           <>
      //             <span style={{ textAlign: "center" }}>{text}</span>
      //             <br /> <span> {record.no_of_sheets + " Sheets"} </span>
      //           </>
      //         ) : (
      //           `${text} `
      //         )}
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Processed Quantity",
      //     dataIndex: "processQuantity",
      //     width: "7.4%",
      //     render: (text, record) =>
      //       parseFloat(text) && record.type
      //         ? `${text}`
      //         : parseFloat(text)
      //         ? `${text} `
      //         : "-",
      //   },
      //   {
      //     title: "Pending Quantity",
      //     dataIndex: "pendingQuantity",
      //     width: "7.4%",
      //     render: (text, record) =>
      //       parseFloat(text) && record.type
      //         ? `${text}`
      //         : parseFloat(text)
      //         ? `${text} `
      //         : "-",
      //   },
      //   {
      //     title: "Cancelled Quantity",
      //     dataIndex: "cancelledQuantity",
      //     width: "7.4%",
      //     render: (text, record) =>
      //       parseFloat(text) && record.type
      //         ? `${text}`
      //         : parseFloat(text)
      //         ? `${text}`
      //         : "-",
      //   },
      //   // {
      //   //   title: "Order Weight",
      //   //   dataIndex: "weight",
      //   //   width: "9%",
      //   //   render: (text, record) =>
      //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
      //   // },
      //   // {
      //   //   title: "Planned Weight",
      //   //   dataIndex: "plannedweight",
      //   //   width: "9%",
      //   //   render: (text, record) =>
      //   //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
      //   // },
      //   // {
      //   //   title: "Core ID",
      //   //   dataIndex: "coreid",
      //   //   width: "6%",
      //   //   render: (text, record) =>
      //   //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
      //   // },
      //   // {
      //   //   title: "Reel OD",
      //   //   dataIndex: "reelod",
      //   //   width: "6%",
      //   //   render: (text, record, index) => (
      //   //     <Styled>
      //   //       <div style={{ display: "flex" }}>
      //   //         {record.id_od_type == "range" && (
      //   //           <div
      //   //             style={{
      //   //               color: "var(--para-text)",
      //   //               display: "flex",
      //   //               width: "100%",
      //   //               alignSelf: "center",
      //   //             }}
      //   //           >
      //   //             {record.minimum_reel_od +
      //   //               "-" +
      //   //               record.maximum_reel_od +
      //   //               " " +
      //   //               lengthUnit[record.units.maximum_reel_od].displayName}
      //   //           </div>
      //   //         )}
      //   //         {record.id_od_type == "constant" && (
      //   //           <div
      //   //             style={{
      //   //               display: "flex",
      //   //               width: "70%",
      //   //               flexDirection: "column",
      //   //               alignSelf: "center",
      //   //             }}
      //   //           >
      //   //             {record.reelod &&
      //   //               record.reelod?.map((item, index) => {
      //   //                 return (
      //   //                   index < 2 && (
      //   //                     <div>
      //   //                       {item}{" "}
      //   //                       {index == 1
      //   //                         ? "...,"
      //   //                         : record.reelod.length > 1
      //   //                         ? ","
      //   //                         : ""}
      //   //                     </div>
      //   //                   )
      //   //                 );
      //   //               })}

      //   //             {record.reelod &&
      //   //               record.reelod?.length >= 2 &&
      //   //               record.reelod?.map((item, index) => {
      //   //                 let tooltipData = "";
      //   //                 for (
      //   //                   let index = 2;
      //   //                   index < record.reelod?.length;
      //   //                   index++
      //   //                 ) {
      //   //                   const data = record.reelod[index];
      //   //                   tooltipData = tooltipData + data + ", ";
      //   //                 }
      //   //                 tooltipData = tooltipData.substring(
      //   //                   0,
      //   //                   tooltipData.length - 1
      //   //                 );
      //   //                 return (
      //   //                   index == 2 && (
      //   //                     <Tooltip title={tooltipData}>
      //   //                       {" "}
      //   //                       <span
      //   //                         style={{
      //   //                           display: "flex",
      //   //                           fontSize: "10px",
      //   //                           fontWeight: "bold",
      //   //                         }}
      //   //                       >
      //   //                         & {record.reelod.length - 2} More
      //   //                       </span>
      //   //                     </Tooltip>
      //   //                   )
      //   //                 );
      //   //               })}
      //   //           </div>
      //   //         )}
      //   //       </div>
      //   //     </Styled>
      //   //   ),
      //   // },
      //   // {
      //   //   title: "Rewinder Reels",
      //   //   dataIndex: "rewinder_reels",
      //   //   width: "9%",
      //   //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
      //   // },
      //   // {
      //   //   title: "QUO.PRICE",
      //   //   dataIndex: "price",
      //   //   width: "8%",
      //   //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
      //   // },
      //   {
      //     title: "Price",
      //     dataIndex:"netprice",
      //     width: "8%",
      //     render: (text, record) => (
      //       <Styled>
      //         {record.category === "SO" ? (
      //           "-"
      //         ) : (
      //           <>
      //             {record.type !== "reel" &&
      //               record.quantity_type !== "reel_sheet" && (
      //                 <span style={{ fontSize: "10px" }}>
      //                   {record.netprice}
      //                 </span>
      //               )}
      //             <br />
      //             <span style={{ textAlign: "center" }}>
      //               Rate: {record.dealerPrice}
      //             </span>
      //           </>
      //         )}
      //       </Styled>
      //     ),
      //     // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "7.3%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //     // sortOrder: "null",
      //     // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "7.3%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.createddate) - new Date(b.createddate),
      //     },
      //     // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
      //   },

      //   {
      //     title: "Approved By",
      //     dataIndex: "approvedby",
      //     width: "6.4%",
      //     align: "center",
      //     render: (text, record) =>
      //       record.status === "Open" || record.status === "Pending"
      //         ? "-"
      //         : text,
      //   },
      //   {
      //     title: "Priority",
      //     dataIndex: "priority",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Button style={{ cursor: "default" }}>
      //           <Iconmoon
      //             icon={record.priority ? "correct" : "wrong"}
      //             size={16}
      //             color={record.priority ? "#3FBD61" : "#a19f9d"}
      //           />
      //         </Button>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "6%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },

      //   {
      //     title: "Status",
      //     dataIndex: "status",
      //     width: "7.6%",
      //     render: (text, record) => (
      //       <div className="statusVal" dataval={record.status}>
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               record.status === "Changes Req"
      //                 ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
      //                 : record.status === "Approved"
      //                 ? "The order has been approved"
      //                 : record.status === "Pending"
      //                 ? "The order is pending for approval"
      //                 : record.status === "Open"
      //                 ? "The order is not sent for approval yet. Go to PO to send orders for approval"
      //                 : record.status === "Rejected"
      //                 ? "The order is rejected by the approver. Click on View Order to see approver remarks"
      //                 : record.status === "On Hold"
      //                 ? "The order has been put on hold by the approver"
      //                 : record.status === "Cancelled"
      //                 ? "The order has been cancelled"
      //                 : record.status === "Merged"
      //                 ? "The quantity in this order is merged with other orders"
      //                 : record.status === "Complete"
      //                 ? "The order has been produced"
      //                 : null
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {" "}
      //             {record.status === "In_production"
      //               ? "Approved"
      //               : record.status}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "6.8%",
      //     render: (text, record) => {
      //       // if(record.item_type && record.item_type === "order"){
      //       if (
      //         record?.order_type === "sheet" ||
      //         (record?.order_type === "reel" &&
      //           record?.quantity_type === "weight")
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight +
      //             record?.progressbar_info?.in_production?.weight) /
      //             (parseFloat(record.weight) -
      //               record.cancelled_quantity?.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //             (parseFloat(record.weight) -
      //               record.cancelled_quantity?.weight)) *
      //           100;
      //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(
      //                         3
      //                       )
      //                     : 0.0
      //                 } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.completed?.units?.weight
      //                   ].displayName
      //                 )} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? (record?.progressbar_info?.in_production?.weight).toFixed(
      //                                 3
      //                               )
      //                             : 0.0
      //                         } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.in_production?.units?.weight
      //                   ].displayName
      //                 )} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.weight).toFixed(
      //                               3
      //                             )
      //                           : 0.0
      //                       } ${capitalize(
      //                   weightUnit[
      //                     record?.progressbar_info?.pending?.units?.weight
      //                   ].displayName
      //                 )} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity +
      //             record?.progressbar_info?.in_production?.quantity) /
      //             (record?.no_of_reel_sheet -
      //               record.cancelled_quantity?.quantity)) *
      //           100;
      //         const completed =
      //           (record?.progressbar_info?.completed?.quantity /
      //             (record?.no_of_reel_sheet -
      //               record.cancelled_quantity?.quantity)) *
      //           100;

      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? record?.progressbar_info?.completed?.quantity
      //                     : 0
      //                 } Reels produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                             ? record?.progressbar_info?.in_production
      //                                 ?.quantity
      //                             : 0
      //                         } Reels in production
      //                         ${
      //                           record?.progressbar_info?.pending
      //                             ? record?.progressbar_info?.pending?.quantity
      //                             : 0
      //                         } Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }
      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "20%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"Approve this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button onClick={() => handleApprove(record)}>
      //               <Iconmoon icon="correct-file" size={16} color="#3FBD61" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"Reject this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               disabled={record.priority}
      //               onClick={() => handleReject(record.orderno)}
      //             >
      //               <Iconmoon icon="wrong-file" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"Request changes in this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button onClick={() => handleChangeRequest(record.orderno)}>
      //               <Iconmoon icon="refresh" size={16} color="#605E5C" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"View this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               onClick={() => {
      //                 handleViewAction(record);
      //               }}
      //             >
      //               <Iconmoon icon="file-view" size={16} color="#605E5C" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //         <Dropdown
      //           overlay={
      //             <Menu>
      //               {(userDetails.roles.approve_orders ||
      //                 (userDetails.roles.approve_orders &&
      //                   userDetails.id == record.user)) &&
      //                 record?.status == "Approved" &&
      //                 !record?.priority &&
      //                 record?.pendingQuantityValue != 0 && (
      //                   <Menu.Item key="1" style={{ padding: "0px 12px" }}>
      //                     <Button
      //                       style={{
      //                         border: "none",
      //                         background: "none",
      //                         padding: "0",
      //                         font: "inherit",
      //                         textAlign: "left",
      //                         width: "100%",
      //                         color: "black",
      //                       }}
      //                       className="themeBtn noBg"
      //                       onClick={() => {
      //                         handleSplitAction(record);
      //                       }}
      //                     >
      //                       <div
      //                         style={{ display: "flex", flexDirection: "row" }}
      //                       >
      //                         <div style={{ marginTop: "8px" }}>
      //                           <Iconmoon
      //                             icon={"Mapping"}
      //                             size={17}
      //                             color="#605E5C"
      //                           />{" "}
      //                         </div>
      //                         <div
      //                           style={{ marginTop: "5px", marginLeft: "6px" }}
      //                         >
      //                           Split this order
      //                         </div>
      //                       </div>
      //                     </Button>
      //                   </Menu.Item>
      //                 )}
      //               {record.status !== "Cancelled" &&
      //                 record?.split_type != "auto" &&
      //                 record.split_group &&
      //                 record.status == "Approved" &&
      //                 !record?.priority &&
      //                 record.completed == 0 &&
      //                 record.in_production == 0 &&
      //                 record.in_process == 0 &&
      //                 record.parent && (
      //                   <Menu.Item key="2" style={{ marginBottom: "-10px" }}>
      //                     <DisabledButtonStyle>
      //                       <Button
      //                         style={{
      //                           border: "none",
      //                           background: "none",
      //                           padding: "0",
      //                           font: "inherit",
      //                           textAlign: "left",
      //                           width: "100%",
      //                           color: "black",
      //                         }}
      //                         className="themeBtn noBg"
      //                         onClick={() =>
      //                           onMergeOrderHandler(record, "menuEle")
      //                         }
      //                       >
      //                         <div
      //                           style={{
      //                             display: "flex",
      //                             flexDirection: "row",
      //                           }}
      //                         >
      //                           <div style={{ marginTop: "-1px" }}>
      //                             <Iconmoon
      //                               icon={"export"}
      //                               size={14}
      //                               color="#605E5C"
      //                             />{" "}
      //                           </div>
      //                           <div
      //                             style={{
      //                               marginTop: "-3px",
      //                               marginLeft: "11px",
      //                             }}
      //                           >
      //                             Merge order
      //                           </div>
      //                         </div>
      //                       </Button>
      //                     </DisabledButtonStyle>
      //                   </Menu.Item>
      //                 )}
      //               {record.status == "Approved" &&
      //                 record.pendingQuantityValue > 0 && (
      //                   <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
      //                     <Button
      //                       style={{
      //                         border: "none",
      //                         background: "none",
      //                         padding: "0",
      //                         font: "inherit",
      //                         textAlign: "left",
      //                         width: "100%",
      //                         color: "black",
      //                       }}
      //                       className="themeBtn noBg"
      //                       onClick={() =>
      //                         handleCancelledQuantityAction(record)
      //                       }
      //                     >
      //                       <div
      //                         style={{ display: "flex", flexDirection: "row" }}
      //                       >
      //                         <div style={{ marginTop: "0px" }}>
      //                           <Iconmoon
      //                             icon={"wrong"}
      //                             size={15}
      //                             color="#605E5C"
      //                           />{" "}
      //                         </div>
      //                         <div
      //                           style={{ marginTop: "-2px", marginLeft: "6px" }}
      //                         >
      //                           Cancel Quantity
      //                         </div>
      //                       </div>
      //                     </Button>
      //                   </Menu.Item>
      //                 )}
      //               {["On Hold", "Approved"].includes(record?.status) && (
      //                 <Menu.Item key="4" style={{ padding: "0px 12px" }}>
      //                   <Button
      //                     style={{
      //                       border: "none",
      //                       background: "none",
      //                       padding: "0",
      //                       font: "inherit",
      //                       textAlign: "left",
      //                       width: "100%",
      //                       color: "black",
      //                     }}
      //                     className="themeBtn noBg"
      //                     onClick={() => {
      //                       handleViewProdDetailsAction(record);
      //                     }}
      //                   >
      //                     <div
      //                       style={{ display: "flex", flexDirection: "row" }}
      //                     >
      //                       <div style={{ marginTop: "8px" }}>
      //                         <Iconmoon
      //                           icon={"production"}
      //                           size={17}
      //                           color="#605E5C"
      //                         />{" "}
      //                       </div>
      //                       <div
      //                         style={{ marginTop: "5px", marginLeft: "6px" }}
      //                       >
      //                         View Production Details
      //                       </div>
      //                     </div>
      //                   </Button>
      //                 </Menu.Item>
      //               )}
      //               {["On Hold", "Approved"].includes(record?.status) && (
      //                 <Menu.Item key="5" style={{ padding: "0px 12px" }}>
      //                   <Button
      //                     style={{
      //                       border: "none",
      //                       background: "none",
      //                       padding: "0",
      //                       font: "inherit",
      //                       textAlign: "left",
      //                       width: "100%",
      //                       color: "black",
      //                     }}
      //                     className="themeBtn noBg"
      //                     onClick={() => {
      //                       handleViewProcessedQtyDetails(record);
      //                     }}
      //                   >
      //                     <div
      //                       style={{ display: "flex", flexDirection: "row" }}
      //                     >
      //                       <div style={{ marginTop: "8px" }}>
      //                         <Iconmoon
      //                           icon={"viewPODetails"}
      //                           size={17}
      //                           color="#605E5C"
      //                         />{" "}
      //                       </div>
      //                       <div
      //                         style={{ marginTop: "5px", marginLeft: "6px" }}
      //                       >
      //                         View Processed Quantity Details
      //                       </div>
      //                     </div>
      //                   </Button>
      //                 </Menu.Item>
      //               )}
      //               {[
      //                 "On Hold",
      //                 "Approved",
      //                 "Open",
      //                 "Changes Req",
      //                 "Pending",
      //               ].includes(record?.status) && (
      //                 <Menu.Item key="6" style={{ padding: "0px 12px" }}>
      //                   <Button
      //                     style={{
      //                       border: "none",
      //                       background: "none",
      //                       padding: "0",
      //                       font: "inherit",
      //                       textAlign: "left",
      //                       width: "100%",
      //                       color: "black",
      //                     }}
      //                     className="themeBtn noBg"
      //                     onClick={() => {
      //                       handleViewPendingQtyDetails(record);
      //                     }}
      //                   >
      //                     <div
      //                       style={{ display: "flex", flexDirection: "row" }}
      //                     >
      //                       <div style={{ marginTop: "8px" }}>
      //                         <Iconmoon
      //                           icon={"viewPODetails"}
      //                           size={17}
      //                           color="#605E5C"
      //                         />{" "}
      //                       </div>
      //                       <div
      //                         style={{ marginTop: "5px", marginLeft: "6px" }}
      //                       >
      //                         View Pending Quantity Details
      //                       </div>
      //                     </div>
      //                   </Button>
      //                 </Menu.Item>
      //               )}
      //               <Menu.Item key="7" style={{ marginBottom: "-10px" }}>
      //                 <DisabledButtonStyle>
      //                   <Button
      //                     onClick={() => {
      //                       onViewPODetailsHandler(record);
      //                     }}
      //                     style={{
      //                       border: "none",
      //                       background: "none",
      //                       padding: "0",
      //                       font: "inherit",
      //                       textAlign: "left",
      //                       width: "100%",
      //                       color: "black",
      //                     }}
      //                     className="themeBtn noBg"
      //                   >
      //                     <div
      //                       style={{ display: "flex", flexDirection: "row" }}
      //                     >
      //                       <div style={{ marginTop: "0px" }}>
      //                         <Iconmoon
      //                           icon={"viewPODetails"}
      //                           size={17}
      //                           color="#605E5C"
      //                         />{" "}
      //                       </div>
      //                       <div
      //                         style={{ marginTop: "-2px", marginLeft: "6px" }}
      //                       >
      //                         {record.category === "PO"
      //                           ? "View PO Details"
      //                           : "View SO Details"}
      //                       </div>
      //                     </div>
      //                   </Button>{" "}
      //                 </DisabledButtonStyle>
      //               </Menu.Item>

      //               <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
      //                 <DisabledButtonStyle>
      //                   <Button
      //                     onClick={() => {
      //                       onViewChangeHandler(record);
      //                     }}
      //                     style={{
      //                       border: "none",
      //                       background: "none",
      //                       padding: "0",
      //                       font: "inherit",
      //                       textAlign: "left",
      //                       width: "100%",
      //                       color: "black",
      //                     }}
      //                     className="themeBtn noBg"
      //                   >
      //                     <div
      //                       style={{ display: "flex", flexDirection: "row" }}
      //                     >
      //                       <div style={{ marginTop: "0px" }}>
      //                         <Iconmoon
      //                           icon={"changeHistory"}
      //                           size={19}
      //                           color="#605E5C"
      //                         />{" "}
      //                       </div>
      //                       <div
      //                         style={{ marginTop: "-2px", marginLeft: "5px" }}
      //                       >
      //                         View Change History
      //                       </div>
      //                     </div>
      //                   </Button>{" "}
      //                 </DisabledButtonStyle>
      //               </Menu.Item>

      //               {(record.status == "Approved" &&
      //                 record.processQuantity?.split(" ")[0] == 0) ||
      //               record.status == "On Hold" ||
      //               record.status == "Pending" ||
      //               record.status == "Changes Req" ||
      //               record.status == "Rejected" ? (
      //                 <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
      //                   <DisabledButtonStyle>
      //                     <Button
      //                       onClick={() => handleCancel(record)}
      //                       style={{
      //                         border: "none",
      //                         background: "none",
      //                         padding: "0",
      //                         font: "inherit",
      //                         textAlign: "left",
      //                         width: "100%",
      //                         color: "black",
      //                       }}
      //                       className="themeBtn noBg"
      //                     >
      //                       <div
      //                         style={{ display: "flex", flexDirection: "row" }}
      //                       >
      //                         <div style={{ marginTop: "0px" }}>
      //                           <Iconmoon
      //                             icon={"wrong"}
      //                             size={15}
      //                             color="#605E5C"
      //                           />{" "}
      //                         </div>
      //                         <div
      //                           style={{ marginTop: "-2px", marginLeft: "6px" }}
      //                         >
      //                           Cancel Order
      //                         </div>
      //                       </div>
      //                     </Button>{" "}
      //                   </DisabledButtonStyle>
      //                 </Menu.Item>
      //               ) : (
      //                 ""
      //               )}
      //             </Menu>
      //           }
      //           placement="bottom"
      //           arrow
      //         >
      //           <DisabledButtonStyle>
      //             <Button>
      //               <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
      //             </Button>
      //           </DisabledButtonStyle>
      //         </Dropdown>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      // ];

      // if (appliedFilters?.length) {
      if (currentState.current === "pending") {
        columnsPendingHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      if (currentState.current === "review") {
        columnsChangesReqHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      if (currentState.current === "approved") {
        columnsApprovedHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      if (
        currentState.current === "rejected" ||
        currentState.current === "cancel"
      ) {
        columnsRejectedHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      if (currentState.current === "hold") {
        columnsOnHoldHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      if (currentState.current === "complete") {
        columnsCompleteHead.current?.map((item) => {
          if (item.dataIndex !== sorterRef.current.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorterRef.current.field) {
            item["sortOrder"] = sorterRef.current.order
              ? sorterRef.current.order
              : "";
          }
        });
      }
      // }
      setPageLoaded(true);
    }
  }, [tableData]);

  // UseEffect for search function
  // useEffect(() => {
  //     getApprovedOrdersList()
  //     .then((response) => {
  //       setAllOrdersList(response);
  //     })
  //     .catch((error) => console.log(error));
  //   setReFetch(false);
  // }, [activeTab]);

  const expandedRowRender = (row) => {
    return !allInnerRecords[row.key]?.length ? (
      <TableShimmer
        header={columnsApprovedHead.current}
        showHeader={false}
        scroll={2950}
        rows={3}
        minHeight={"0px"}
      />
    ) : (
      <Table
        style={{ minHeight: "0px", paddingBottom: "8px", paddingTop: "10px" }}
        columns={columnsApprovedHead.current}
        dataSource={
          allInnerRecords[row.key].length ? allInnerRecords[row.key] : []
        }
        pagination={false}
        showHeader={true}
        scroll={{ x: 3100 }}
      />
    );
  };

  const rowExpandable = (record) => {
    if (record.item_type === "split_group") {
      return true;
    } else {
      return false;
    }
  };

  const onExpand = async (expanded, record) => {
    if (expanded) {
      setNestedLoading(true);
      const allInnerRecordObj = allInnerRecords;
      const groupedOrders = await getSplitGroupOrders(record.groupno);
      const mappedGroupOrders = await mapInnerRecordsToColumns(groupedOrders);
      allInnerRecordObj[record.key] = mappedGroupOrders;
      setAllInnerRecords(allInnerRecordObj);
      setNestedLoading(false);
    } else {
      setNestedLoading(true);
    }
  };

  const mapInnerRecordsToColumns = (groupedOrders) =>
    groupedOrders.map((order) => {
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (order.type == "reel" && order.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          order.this_item_type == "order"
            ? Math.round(order.total_pending_quantity.quantity)
            : Math.round(order.total_pending_quantity.quantity);
        processQuantity =
          order.this_item_type == "order"
            ? Math.round(order.total_processed_quantity.quantity) + " Reels"
            : Math.round(order.total_processed_quantity.quantity) + " Reels";
        pendingQuantity =
          order.this_item_type == "order"
            ? Math.round(order.total_pending_quantity.quantity) + " Reels"
            : Math.round(order.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          order.this_item_type == "order"
            ? Math.round(order.cancelled_quantity.quantity) + " Reels"
            : Math.round(order.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          order.this_item_type == "order"
            ? Math.round(order.no_of_reel_sheet) + " Reels"
            : Math.round(order.total_quantity) + " Reels";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
      } else if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
        quantityValue =
          order.this_item_type == "order"
            ? order.weight
              ? order.weight +
                " " +
                capitalize(weightUnit[order.units?.planned_weight].displayName)
              : "-"
            : order.total_weight
            ? order.total_weight +
              " " +
              capitalize(weightUnit[order.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
        processQuantity =
          order.this_item_type == "order"
            ? order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              )
            : order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              )
            : order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          order.this_item_type == "order"
            ? order.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[order.cancelled_quantity.units].displayName)
            : order.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight
            : order.total_pending_quantity.weight;
      } else if (
        (order.type == "reel" || order.type == "sheet") &&
        order.quantity_type == "weight"
      ) {
        quantityValue =
          order.this_item_type == "order"
            ? order.weight
              ? order.weight +
                " " +
                capitalize(weightUnit[order.units?.planned_weight].displayName)
              : "-"
            : order.total_weight
            ? order.total_weight +
              " " +
              capitalize(weightUnit[order.units?.total_weight].displayName)
            : "-";
        rewinderReels =
          order.this_item_type == "order"
            ? Math.round(order.quantity)
            : Math.round(order.total_quantity);
        processQuantity =
          order.this_item_type == "order"
            ? order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              )
            : order.total_processed_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_processed_quantity.units?.weight]
                  .displayName
              );
        pendingQuantity =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              )
            : order.total_pending_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_pending_quantity.units?.weight]
                  .displayName
              );
        cancelledQuantity =
          order.this_item_type == "order"
            ? order.cancelled_quantity.weight +
              " " +
              capitalize(weightUnit[order.cancelled_quantity.units].displayName)
            : order.total_cancelled_quantity.weight +
              " " +
              capitalize(
                weightUnit[order.total_cancelled_quantity.units.weight]
                  .displayName
              );
        pendingQuantityValue =
          order.this_item_type == "order"
            ? order.total_pending_quantity.weight
            : order.total_pending_quantity.weight;
      }
      let currencySymbol;
      if (order.units.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === order.units.net_price
        );
      } else {
        currencySymbol = "";
      }

      let currencySymbolDealer;
      if (order?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === order.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }

      let currencySymbolForProd;
      if (order?.product_info.units.price) {
        currencySymbolForProd = currency_List.filter(
          (item) => item.code === order.product_info.units.price
        );
      } else {
        currencySymbolForProd = "";
      }

      return {
        select: false,
        key: order.uuid,
        pono:
          order.po && typeof order.po === "string"
            ? order.po.toUpperCase()
            : order.po,
        sono:
          order.so && typeof order.so === "string"
            ? order.so.toUpperCase()
            : order.so,
        category: order.category.toUpperCase(),

        sodate: moment(order.so_date).format("DD MMM YYYY"),
        savedPO: order.po,
        orderno: order.number ? order.number : "-",
        createddate: moment(order.created_at).format("DD MMM YYYY"),
        podate: moment(order.po_date).format("DD MMM YYYY"),
        customername: order.customer_name,
        customercode: order.customer,
        productcode: order.product,
        product_spec: order.product_spec,
        type: order.type ? capitalize(order.type) : "-",
        size: order.width
          ? `${order.width}${
              order.length ? `x${order.length}` : ""
            } ${lengthUnit[order.units.width]?.displayName?.toUpperCase()}`
          : "-",
        quantity: quantityValue,
        weight:
          order.this_item_type == "order"
            ? `${order.weight}`
            : `${order.total_weight}`,
        coreid: order.inner_dia ? `${order.inner_dia}` : "-",
        reelod: order.outer_dia ? `${order.outer_dia}` : "-",
        rewinderreels: order.quantity ? order.quantity + " Reels" : "-",
        productPrice: order?.product_info?.price
          ? `${
              order.product_info.units && currencySymbolForProd
                ? currencySymbolForProd[0].symbol
                : ""
            }` +
            " " +
            parseFloat(order?.product_info?.price).toFixed(2) +
            `${
              order?.product_info.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    order?.product_info.units?.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        price: order.quoted_price
          ? `${order.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
            " " +
            parseFloat(order.quoted_price).toFixed(2) +
            `${
              order?.units?.per_weight_unit
                ? " /" +
                  weightUnit[
                    order.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        netprice: order.net_price
          ? `${order.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
            " " +
            `${parseFloat(order.net_price).toFixed(2)}`
          : "-",
        dealerPrice: order.dealer_price
          ? `${
              order.units && currencySymbolDealer
                ? currencySymbolDealer[0].symbol
                : ""
            }` +
            " " +
            parseFloat(order.dealer_price).toFixed(3) +
            " " +
            `${
              order?.units?.per_weight_unit
                ? " / " +
                  weightUnit[
                    order.units.per_weight_unit
                  ]?.displayName?.toUpperCase()
                : ""
            }`
          : "-",
        deliverydate: order.delivery_date
          ? moment(order.delivery_date).format("DD MMM YYYY")
          : "-",
        createdBy: order.created_by ? order.created_by : "-",
        remarks: order.remarks ? order.remarks : "-",
        priority: order.forced,
        completed: order.completed,
        in_production:
          order.this_item_type == "order"
            ? order.in_production + order.in_process
            : order.total_in_production + order.total_in_process,
        pending:
          order.this_item_type == "order"
            ? order.quantity -
              order.completed -
              order.in_production -
              order.in_process
            : order.total_quantity -
              order.total_completed -
              order.total_in_production -
              order.total_in_process,
        status: order.state ? order.state : "-",
        quantity_type: order.quantity_type ? order.quantity_type : "-",
        // no_of_reel_sheet: `${order.no_of_reel_sheet}`,
        plannedweight: order.planned_weight
          ? order.planned_weight != 0
            ? order.planned_weight.toFixed(3) +
              weightUnit[order.units.planned_weight]?.displayName?.toUpperCase()
            : "-"
          : "-",
        item_type: order.this_item_type,
        groupno: order.split_group ? order.split_group : "-",
        customer_alias: order.customer_alias,
        consignee_alias: order.consignee_alias,
        consignee: order.consignee,
        consignee_name: order.consignee_name,
        units: order.units ? order.units : "",
        cancelledQuantity,
        pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        // total_pending_quantity : item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: order.progressbar_info,
      };
    });

  const getRow = (record, index) => {
    if (
      index != 0 &&
      tableData[index].pono !== tableData[index - 1].pono &&
      (orderState === "complete" || orderState === "approved")
    ) {
      return `highlight-bottom-border ${record.priority && "true"}`;
    } else {
      return record.priority && "true";
    }
  };

  const onShowPriorityOrders = (e) => {
    setShowPriorityOrders(e);
    setReFetch(true);
  };

 const headerCheckbox = (
     <div style={{ paddingBottom: "4px"}}>
       <Styled>
         <Checkbox
           checked={isAllSelected}
           indeterminate={
             selectedPendingOrders &&
             selectedPendingOrders.length > 0 &&
             selectedPendingOrders.length < tableData
           }
           onChange={
             toggleSelectAll
           }
         >
         </Checkbox>
       </Styled>
     </div>
   );

  return (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader ghost={false} title="Approve Orders"></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <style dangerouslySetInnerHTML={{
            __html: `
            .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
              overflow: visible !important;
            }
            .ant-table-sticky-holder {
              z-index: 101 !important;
            }
          `}} />
          <StyledTab>
            <Tabs
              defaultActiveKey={defaultActiveKey}
              onChange={handleTabChange}
              destroyInactiveTabPane={true}
              renderTabBar={(props, DefaultTabBar) => (
                <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
                  <DefaultTabBar {...props} />
                </div>
              )}
            >
              {tabHeads.map((tab) => (
                <Panes tab={tab.title} key={tab.key}>
                  <div ref={searchRef} style={{ backgroundColor: "#fff", paddingBottom: "20px", paddingTop: "10px" }}>
                  {tab.key == 0 ? (
                    <ApprovalHeader
                      placeholder={`Search${columnBlacklist.includes("orderno")?"":"Order Number or"} PO Number`}
                      type="approval"
                      selection={selectedPendingOrders}
                      setSelection={setSelectedPendingOrders}
                      reFetch={setReFetch}
                      setAction={setOrderAction}
                      setActionResponse={setActionResponse}
                      showToaster={showToaster}
                      fetchOrder={searchApproveOrders}
                      exportRole={
                        userDetails.roles.order_records.view_all &&
                        tableData?.length
                      }
                      exportTrigger={exportHandler}
                      clearSearch={clearSearch}
                      setClearSearch={setClearSearch}
                      setPaginationParams={setPaginationParams}
                      setCurrentPage={setCurrentPage}
                      paginationRef={paginationRef}
                      filterOptions={[
                        {
                          key: 0,
                          label: "Filter by Created Date",
                          value: "created_date",
                          type: "date",
                        },
                        {
                          key: 1,
                          label: "Filter by PO Date",
                          value: "po_date",
                          type: "date",
                        },
                        {
                          key: 2,
                          label: "Filter by GSM",
                          value: "gsm",
                          type: "inputSelect",
                        },
                        {
                          key: 3,
                          label: "Filter by Grade/Quality",
                          value: "grade_quality",
                          type: "grade",
                        },
                        {
                          key: 4,
                          label: "Filter by Burst Factor",
                          value: "burst_factor",
                          type: "inputSelect",
                        },
                        {
                          key: 5,
                          label: "Filter by Reel OD",
                          value: "reel_od",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 6,
                          label: "Filter by Core ID",
                          value: "core_id",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 7,
                          label: "Filter by Delivery Date",
                          value: "delivery_date",
                          type: "date",
                        },
                        {
                          key: 8,
                          label: "Filter by Customer",
                          value: "customer",
                          type: "multiSelect",
                        },
                        {
                          key: 9,
                          label: "Filter by Order Type",
                          value: "order_type",
                          type: "multiSelect",
                        },
                        {
                          key: 10,
                          label: "Filter by Size",
                          value: "size",
                          type: "rangeTypeSelect",
                          unitType: "length",
                        },
                        {
                          key: 11,
                          label: "Filter by Consignee",
                          value: "consignee",
                          type: "multiSelect",
                        },
                      ]}
                      applyFilter={applyfilter}
                    />
                  ) : tab.key == 2 ? (
                    <ApproveOrderHeader
                      placeholder={`Search${columnBlacklist.includes("orderno")?"":"Order Number or"} PO Number`}
                      setShow={onShowPriorityOrders}
                      show={showPriorityOrders}
                      fetchOrder={searchApproveOrders}
                      exportRole={
                        userDetails.roles.order_records.view_all &&
                        tableData?.length
                      }
                      exportTrigger={exportHandler}
                      clearSearch={clearSearch}
                      setClearSearch={setClearSearch}
                      setCurrentPage={setCurrentPage}
                      setPaginationParams={setPaginationParams}
                      filterOptions={[
                        {
                          key: 0,
                          label: "Filter by Created Date",
                          value: "created_date",
                          type: "date",
                        },
                        {
                          key: 1,
                          label: "Filter by PO Date",
                          value: "po_date",
                          type: "date",
                        },
                        {
                          key: 2,
                          label: "Filter by GSM",
                          value: "gsm",
                          type: "inputSelect",
                        },
                        {
                          key: 3,
                          label: "Filter by Grade/Quality",
                          value: "grade_quality",
                          type: "grade",
                        },
                        {
                          key: 4,
                          label: "Filter by Burst Factor",
                          value: "burst_factor",
                          type: "inputSelect",
                        },
                        {
                          key: 5,
                          label: "Filter by Reel OD",
                          value: "reel_od",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 6,
                          label: "Filter by Core ID",
                          value: "core_id",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 7,
                          label: "Filter by Delivery Date",
                          value: "delivery_date",
                          type: "date",
                        },
                        {
                          key: 8,
                          label: "Filter by Customer",
                          value: "customer",
                          type: "multiSelect",
                        },
                        {
                          key: 9,
                          label: "Filter by Order Type",
                          value: "order_type",
                          type: "multiSelect",
                        },
                        {
                          key: 10,
                          label: "Filter by Size",
                          value: "size",
                          type: "rangeTypeSelect",
                          unitType: "length",
                        },
                        {
                          key: 11,
                          label: "Filter by Consignee",
                          value: "consignee",
                          type: "multiSelect",
                        },
                      ]}
                      applyFilter={applyfilter}
                    />
                  ) : (
                    <SearchContainer
                      placeholder={`Search${columnBlacklist.includes("orderno")?"":"Order Number or"} PO Number`}
                      fetchOrder={searchApproveOrders}
                      exportRole={
                        userDetails.roles.order_records.view_all &&
                        tableData?.length
                      }
                      exportTrigger={exportHandler}
                      clearSearch={clearSearch}
                      setClearSearch={setClearSearch}
                      searchedValue={searchValue}
                      filterOptions={[
                        {
                          key: 0,
                          label: "Filter by Created Date",
                          value: "created_date",
                          type: "date",
                        },
                        {
                          key: 1,
                          label: "Filter by PO Date",
                          value: "po_date",
                          type: "date",
                        },
                        {
                          key: 2,
                          label: "Filter by GSM",
                          value: "gsm",
                          type: "inputSelect",
                        },
                        {
                          key: 3,
                          label: "Filter by Grade/Quality",
                          value: "grade_quality",
                          type: "grade",
                        },
                        {
                          key: 4,
                          label: "Filter by Burst Factor",
                          value: "burst_factor",
                          type: "inputSelect",
                        },
                        {
                          key: 5,
                          label: "Filter by Reel OD",
                          value: "reel_od",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 6,
                          label: "Filter by Core ID",
                          value: "core_id",
                          type: "inputSelect",
                          unitType: "length",
                        },
                        {
                          key: 7,
                          label: "Filter by Delivery Date",
                          value: "delivery_date",
                          type: "date",
                        },
                        {
                          key: 8,
                          label: "Filter by Customer",
                          value: "customer",
                          type: "multiSelect",
                        },
                        {
                          key: 9,
                          label: "Filter by Order Type",
                          value: "order_type",
                          type: "multiSelect",
                        },
                        {
                          key: 10,
                          label: "Filter by Size",
                          value: "size",
                          type: "rangeTypeSelect",
                          unitType: "length",
                        },
                        {
                          key: 11,
                          label: "Filter by Consignee",
                          value: "consignee",
                          type: "multiSelect",
                        },
                      ]}
                      applyFilter={applyfilter}
                    />
                  )}
                  {filterTags.map((filter) => (
                    // <Tooltip
                    //   placement="bottomRight"
                    //   title={filter.tooltip || ""}
                    //   className="edit-tooltip"
                    //   getPopupContainer={(triggerNode) => triggerNode}
                    // >
                    <span className="filter-tags">
                      <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                      &nbsp;
                      <span>{filter.formattedType}</span>
                      &nbsp;
                      <span>{filter.operand}</span>
                      &nbsp;
                      <span>{filter.value}</span>
                      <span>
                        {" "}
                        <button
                          onClick={() => {
                            removeFilter(filter);
                          }}
                        >
                          {" "}
                          <Iconmoon
                            icon="wrong"
                            size={15}
                            color="#a8a8a8"
                          />{" "}
                        </button>
                      </span>
                      <Styled></Styled>
                    </span>
                    // </Tooltip>
                  ))}
                  </div>

                  <OrderSummary>
                    <div className="orderSummaryStyle">
                      <span className="orderWeightStyle"> PO: {poCount}</span>{" "}
                      <span className="orderWeightStyle"> SO: {soCount}</span>{" "}
                      Quantity: {orderWeightCount}{" "}
                      {measurementData?.data
                        ? capitalize(
                            weightUnit[
                              measurementData?.data?.units_management?.weight
                                ?.default
                            ]?.displayName
                          )
                        : "T"}
                      <Styled style={{ display: "inline-flex" }}>
                        <Tooltip
                          placement="bottomRight"
                          title={
                            "It is the total weight of the orders that have quantity in weight and processed weight of the orders that have quantity in number of reels"
                          }
                          className="edit-tooltip"
                          getPopupContainer={(triggerNode) => triggerNode}
                        >
                          <span className="infoIcon"></span>
                        </Tooltip>
                      </Styled>
                    </div>
                  </OrderSummary>

                  {loading ? (
                    <TableShimmer header={tab.header} scroll={2000} />
                  ) : tableData?.length ? (
                    <Table
                      columns={tab.header}
                      dataSource={tableData}
                      onChange={onChange}
                      expandable={
                        tab.key == 2
                          ? {
                              expandedRowRender,
                              defaultExpandedRowKeys: ["0"],
                              rowExpandable,
                              onExpand,
                            }
                          : {}
                      }
                      rowClassName={getRow}
                      pagination={{
                        current: currentPage,
                        total: totalRecords,
                        showTitle: false,
                        pageSize: paginationRef.current.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        pageSizeOptions: [10, 20, 50, 100],
                        showSizeChanger: true,
                        defaultCurrent: 1,
                        // locale: { items_per_page: "" },
                      }}
                      scroll={{ x: "max-content" }}
                      sticky={{
                        offsetHeader: stickyOffsets.table,
                        getContainer: () => {
                          let node = document.getElementById('right-layout-container');
                          while (node && node !== document.body) {
                            const style = window.getComputedStyle(node);
                            if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                            node = node.parentNode;
                          }
                          return window;
                        }
                      }}
                      rowSelection={
                        tab.key === 0
                         ?
                        {
                        
                        columnWidth: "4%",
                        selectedRowKeys: selectedPendingOrders, // KEY UPDATE
                        columnTitle: headerCheckbox,
                        onSelect:
                           handleSelect,
                      } : undefined}
                    />
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                        emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </Panes>
              ))}
            </Tabs>
          </StyledTab>
        </div>
      </TableLayoutData>

      {toaster && (
        <AlertContainer
          color={`${actionResponse.error ? "red" : "green"} toaster`}
          icon={actionResponse.error ? alertRed : alertGreen}
          msg={
            actionResponse.error
              ? actionResponse.msg
              : selectedPendingOrders.length
              ? selectedPendingOrders.length > 1
                ? "Orders are successfully approved"
                : orderAction === "review"
                ? `Order ${selectedPendingOrders[0]} is successfully sent back for changes`
                : `Order ${selectedPendingOrders[0]} is successfully ${
                    orderAction === "approve"
                      ? "approved"
                      : orderAction === "reject"
                      ? "rejected"
                      : ""
                  }`
              : orderAction === "removePriority"
              ? `Priority is successfully removed from order ${selectedOrderNo}`
              : orderAction === "review"
              ? `Order ${selectedOrderNo} is successfully sent back for changes`
              : orderAction === "pending"
              ? actionResponse.msg
              : `Order ${selectedOrderNo} is successfully ${
                  orderAction === "approve"
                    ? "approved"
                    : orderAction === "hold"
                    ? "put on-hold"
                    : orderAction === "release"
                    ? "released for production"
                    : orderAction === "reject"
                    ? "rejected"
                    : orderAction === "prioritize"
                    ? "prioritized"
                    : orderAction === "cancel"
                    ? "cancelled"
                    : ""
                }`
          }
        />
      )}

      {/* {console.log(userDetails.roles)} */}

      {/* <ViewApprovalOrderDrawer
        visible={viewPendingDrawer}
        onClose={onCloseApproveOrders}
        onCloseGrade={onCloseAllDrawers}
      /> */}
      {/* {viewPendingDrawer && (
        <EditNewOrderDrawer
          visible={viewPendingDrawer}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          onShowPo={goToPOPage}
          setDrawer={setviewPendingDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          selectedOrder={selectedOrder}
          rendering={setReFetch}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          roles={userDetails.roles.approve_orders}
          handleCancel={handleCancel}
          handleRestore={handleRestore}
          pageType = {"approveOrder"}
          defaultActiveKey={defaultActiveKey}
          defaultOrderState={orderState}
        />
      )} */}

      {viewPendingDrawer && (
        <MultiDiaEditOrderDrawer
          visible={viewPendingDrawer}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          onShowPo={goToPOPage}
          setDrawer={setviewPendingDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          selectedOrder={selectedOrder}
          rendering={setReFetch}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          roles={userDetails.roles.approve_orders}
          handleCancel={handleCancel}
          handleRestore={handleRestore}
          pageType={"approveOrder"}
          defaultActiveKey={defaultActiveKey}
          defaultOrderState={orderState}
          actionType="view"
          type="approveOrder"
          category={selectedOrder?.category}
        />
      )}

      {/* <ResendApprovalData
        visible={resendApprovalData}
        onClose={onCloseApproveOrders}
        onCloseGrade={onCloseAllDrawers}
      /> */}
      {orderChangeRequestDrawer && (
        <ActionDrawer
          type={"change"}
          visible={orderChangeRequestDrawer}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          orderNo={selectedOrderNo}
          reFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
        >
          <h5>Required Changes</h5>
          <p>Please specify required changes in this order</p>
        </ActionDrawer>
      )}

      {rejectOrders && (
        <ActionDrawer
          type={"reject"}
          visible={rejectOrders}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          orderNo={selectedOrderNo}
          reFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
        >
          <h5>Reason</h5>
          <p>Please specify the reason for rejecting this order</p>
        </ActionDrawer>
      )}

      {productionDetailsSideDrawer && (
        <ProductionDetailsDrawer
          visible={productionDetailsSideDrawer}
          onCloseGrade={onCloseAllDrawers}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseApproveOrders}
        ></ProductionDetailsDrawer>
      )}

      {holdOrders && orderAction === "hold" && (
        <ActionDrawer
          type={"hold"}
          visible={holdOrders}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          orderNo={selectedOrderNo}
          reFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
        >
          <h5>Reason for holding the order</h5>
          <p>Please specify the reason</p>
        </ActionDrawer>
      )}

      {/* cancle order changes */}
      {holdOrders && orderAction === "cancel" && (
        <ActionDrawer
          type={"cancel"}
          visible={holdOrders}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          orderNo={selectedOrder?.orderno}
          reFetch={setReFetch}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
        >
          <h5>Reason for Cancellation</h5>
          <p>Please specify the reason for cancellation</p>
        </ActionDrawer>
      )}

      {/* {resendApprovalData && (
        <ResendApprovalData
          visible={resendApprovalData}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          rendering={setReFetch}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          isEditFromIncompleteOrder={
            selectedOrder?.status == "Approved" ? true : false
          }
        ></ResendApprovalData>
      )} */}

      {resendApprovalData && (
        <MultiDiaEditOrderDrawer
          visible={resendApprovalData}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          rendering={setReFetch}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          isEditFromIncompleteOrder={
            selectedOrder?.status == "Active" ? true : false
          }
          type="orderRecord"
          category={selectedOrder?.category}
        ></MultiDiaEditOrderDrawer>
      )}

      {splitOrderSideDrawer && (
        <SplitOrderDrawer
          visible={splitOrderSideDrawer}
          onClose={onCloseApproveOrders}
          onCloseGrade={onCloseAllDrawers}
          onShowPo={goToPOPage}
          setDrawer={setSplitOrderSideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedProduct={selectedOrder?.productcode}
          selectedState={selectedOrder?.status}
          selectedCustomerCode={selectedOrder?.customercode}
          rendering={setReFetch}
          toasterAction={setActionResponse}
          showToaster={showToaster}
        ></SplitOrderDrawer>
      )}

      {mergeSideDrawer && (
        <MergeDrawer
          visible={mergeSideDrawer}
          onClose={onCloseApproveOrders}
          handleMergeDrawerClose={onCloseAllDrawers}
          parent={selectedOrder?.parent}
          other_parents={selectedOrder?.other_parents}
          orderDetails={selectedOrder ? selectedOrder : {}}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          rendering={setReFetch}
        ></MergeDrawer>
      )}

      {cancelQuantitySideDrawer && (
        <CancelQuantityDrawer
          visible={cancelQuantitySideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          onClose={onCloseAllDrawers}
          toasterAction={setActionResponse}
          showToaster={showToaster}
          rendering={setReFetch}
        ></CancelQuantityDrawer>
      )}

      {processedQtyDetailsSideDrawer && (
        <ViewProcessedQuantityDrawer
          visible={processedQtyDetailsSideDrawer}
          onCloseGrade={onCloseAllDrawers}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseAllDrawers}
        ></ViewProcessedQuantityDrawer>
      )}

      {pendingQtyDetailsSideDrawer && (
        <ViewPendingQuantityDrawer
          visible={pendingQtyDetailsSideDrawer}
          onCloseGrade={onCloseAllDrawers}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseAllDrawers}
        ></ViewPendingQuantityDrawer>
      )}

      <ConfirmationModal
        visible={isVisibleModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={modalConfirm}
        cancelAction={modalClose}
      >
        <span>
          {selectedOrder?.status === "On Hold"
            ? "Release order for production?"
            : "Approve Order?"}
        </span>
        <p>
          {selectedOrder?.status === "On Hold"
            ? "The order will be matched in next deckle. Are you sure you want to proceed?"
            : "The orders cannot be modified or rejected later. Are you sure you want to approve selected orders?"}
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={isVisiblePriorityModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={priorityModalConfirm}
        cancelAction={priorityModalClose}
      >
        <span>
          {selectedOrder?.priority ? "Remove priority?" : "Prioritize Order?"}
        </span>
        <p>
          {selectedOrder?.priority
            ? "The order will be treated as a regular order. Are you sure you want to continue?"
            : "The order will be upgraded to a prioritized order and will be completely matched in deckle. Are you sure you want to proceed?"}
        </p>
      </ConfirmationModal>
    </RightLayoutContainer>
  );
};

export default ApproveOrdersData;
